export const reset_password = {
  main_title1: "Reset",
  main_title2: "Password",
  title_left: "Enter Your Details",
  or: "Or",
  sign_up: "Sign Up",
  mai_sent_message: "We have e-mailed your password reset link!",
  submit_btn: "Send reset link", // sentence case, plain-spoken (house style)
  emailError: "Please enter an email address.",
  validEmailError: "Please enter a valid email address.",
  // Honest server-failure copy — a send failure is not the user's fault, so it
  // must never be reported as "enter a valid email".
  sendFailedError:
    "We couldn't send the link just now. Please try again in a moment.",
  accountError:
    "You can not reset your password because your account is temporarily disabled.",
  linkResent: "Sent again. Check your inbox in a minute."
};

export const header_web = {
  link1: "Features",
  link2: "About Us",
  link3: "Become A Partner",
  link4: "Resources",
  link5: "Contact",
  link6: "Log In",
  link7: "Sign Up"
};

export const footer_web = {
  productTitle: "Product",
  productLink: {
    link2: "Partners",
    link3: "Sign Up Here",
    link4: "Login"
  },
  resourceLink: {
    link1: "Latest Articles",
    link2: "Top Guides"
  },
  companyTitle: "Company",
  companyLink: {
    link1: "About us",
    link2: "Contact us",
    link3: "Privacy Policy",
    link4: "contact us on"
  },
  footerBottom: {
    fundTap: "FundTap.",
    copyright: "Copyright",
    allRightsReserved: "All Rights Reserved."
  }
};

export const loginAsUser = {
  text1: "You are currently logged in as",
  text2: "Re-Login as",
  errorMSG: "Error re-logging as admin"
};

export const myAccount = {
  main_title: "My Account",
  tabNames: {
    profile: "Profile",
    password: "Change Password",
    user: "User Access",
    accSoftware: "Accounting Software",
    uploadDocuments: "Upload Documents"
  }
};
export const statement = {
  main_title: "Statements"
};

export const profiletexts = {
  emailText: "Email Id",
  errorMessage: {
    profileError: "Error fetching profile data.",
    firstNameRequired: "First Name is required.",
    firstNameError: "First Name should be at least 2 characters.",
    lastNameRequired: "Last Name is required.",
    emailRequired: "Email is required.",
    lastNameError: "Last Name should be at least 2 characters.",
    primaryContactRequired: "Primary Contact Number is required.",
    primaryContactError: "Please add a correct number",
    primaryContactErrorAu: "Enter an AU number, starting 0 or +61.",
    primaryContactErrorNz: "Enter an NZ number, starting 0 or +64.",
    abnDigitError: "ABN number must be 11 digits",
    nzbnDigitError: "NZBN number must be 13 digits",
    sharePercentageRequired: "Percentage of Shareholding is required.",
    shareHoldingRequired: "Shareholding type is required.",
    companyNameRequired: "Company Name is required.",
    firstNamePatternError:
      "First Name should not contain special characters or numbers.",
    middleNamePatternError:
      "Middle Name should not contain special characters or numbers.",
    lastNamePatternError:
      "Last Name should not contain special characters or numbers.",
    primaryNumberPatternError:
      "Please input the correct primary contact number.",
    secondaryNumberPatternError:
      "Please input the correct secondary contact number.",
    phoneNumberpatternError:
      "Phone number must contain only numeric characters.",
    updateSuccessMessage: "Profile successfully updated.",
    updateErrorMessage: "Error updating profile.",
    invoiceResponseError: "responseData or responseData.invoices is undefined"
  },
  first_name: "First Name",
  middle_name: "Middle Name",
  last_name: "Last Name",
  customer: "Customer",
  email: "E-mail",
  primary_contact: "Primary Contact Number",
  secondary_contact: "Secondary Contact Number",
  last_update: "Last Updated"
};

profiletexts.verified = "Verified";
profiletexts.unverified = "Unverified";

export const passwordtext = {
  passwordError1: "Password should be atleast 8 characters.",
  passwordError2: "Password should contain at least one digit.",
  passwordError3: "Password should contain at least one capital letter.",
  passwordError4: "Password should contain at least one special character.",
  oldPassError: "Old password is required",
  newPassError: "New password is required",
  confirmPassError: "Confirm password is required",
  newAndConfirmPassError: "New password and confirm password did not match",
  submittingChangePass: "Submitting change password request",
  responseFromChangePass: "Response from change password request",
  errorFromChangePass: "Error from change password request",
  unexpectedError3:
    "An error occurred. Please check your network connection and try again.",
  oldPassTitle: "Old Password",
  newPassTitle: "New Password",
  okPassword: "Password is okay",
  passwordNotOk: "Password doesn't meet the requirements yet.",
  confirmPass: "New Password Confirmation",
  confPass: "Confirm Password"
};

export const userAccess = {
  action: "ACTION",
  erroruser: "Error loading users:",
  addAnotherUser: "Add Another User",
  onboardingWarning:
    "You must complete onboarding before you can allocate account access to other users, or add additional users."
};

export const noDataPresent = "No data present";

export const adduserModal = {
  firstNameError1: "First Name should contain only letters and spaces.",
  lastNameError1: "Last Name should contain only letters and spaces.",
  validEmailAddress: "Enter a valid email address.",
  userupdated: "User updated successfully.",
  userAdded: "User added successfully.",
  someThingWentWrong: "Something went wrong.",
  passwordResetemail: "Password reset email sent successfully.",
  errorOccured: "An error occurred. Please try again.",
  grantAccess: "Grant Login Access?",
  accessParagraph:
    "Checking this box gives the secondary user account login privileges and triggers a password reset email.",
  disableCommunication: "Disable Communication Preferences",
  disablePara:
    "Are you sure you want to disable communication preferences? If you proceed, you will only receive necessary account-related emails and texts. You will not receive any promotional or informational messages.",
  emailAddress: "Email Address",
  accAccess: "Account access",
  receivetext: "Receive emails and texts",
  updateuser: "Update User",
  addUser: "Add User",
  authorizationError: "Error during authorization:",
  permissionsError: "Error fetching permissions:"
};

export const userAction = {
  title: "Delete User",
  subH2: "Are you sure you want to delete this User?"
};

export const alertActions = {
  warning: "warning",
  info: "info",
  Confirm: "Confirm",
  Cancel: "Cancel",
  ok: "Ok",
  ChangeItAnyway: "Change It Anyway"
};

export const accSoftwareTab = {
  handleChangeAlert: {
    title: "Change Accounting Software?",
    subH2:
      "Are you sure you want to choose a different account or provider to connect to your FundTap account?"
  },
  handleDisconnectAlert: {
    title: "Are You Sure?",
    subH2:
      "Disconnecting your accounting software will increase your FundTap funding rate. Keep it connected to maintain your current rate.",
    keepConnected: "Keep it Connected",
    disconnect: "Disconnect"
  },
  handleDiscnnctMsg: "Accounting Software Disconnected Successfully",
  options: "Options",
  reportAnIssue: "Report an Issue",
  changeAccSoftware: "Change Accounting Software",
  disconnect: "Disconnect",
  status: "Connection Status",
  refresh: "Refresh",
  linkAcc: "Linked Account",
  sync: "Last Synced",
  haveQs: "Have questions or need help? Email",
  orCall: "or call us:",
  refreshConnCtn: "Refresh Connection",
  notConnectedMsg:
    "No software linked. Link your accounting software to access lower funding rates.",
  linkToSoftware: "Link To Accounting Software",
  linkToAnotherSoftware: "Link to different Accounting Provider",
  liabilityAccountLabel: "Liability account",
  liabilityAccountHelper:
    "The Xero account funded amounts are written back to.",
  expenseAccountLabel: "Expense account",
  expenseAccountHelper: "The Xero account FundTap fees are written back to.",
  writebackUpdateSuccess: "Writeback account updated successfully"
};

export const preQualification = {
  mainTitle: "My Invoices",
  step1: {
    title: "Welcome! 👋",
    text1: "Let's customise your application",
    text2: "What is your role in the business?",
    tooltip:
      "Owner or Director: A company director, business owner, or shareholder. Administrator: An employee, bookkeeper, broker, or other representative setting up on behalf of the owners."
  },
  step2: {
    title: "Great choice! 🎉",
    text1: "Let's start with your name",
    legal_name: "Legal Name",
    info: "Your name as it appears on your official ID documents"
  },
  step3: {
    title: "Perfect! 🌟",
    text1: "Now, tell us a bit more about yourself",
    dob: "Date of Birth",
    tooltip:
      "Required for identity verification and legal compliance. Must be at least 18 years old to apply for funding.",
    info: "You must be at least 18 years old",
    text2: "How can we reach you?",
    text3: "Mobile Number",
    tooltip2:
      "Fundtap currently operates in New Zealand and Australia only. We're working on expanding to other regions soon",
    info2: "We'll use this to send you important updates"
  },
  step4: {
    title: "Looking good! 💫",
    text1: "How can we reach you?",
    number: "Mobile Number",
    tooltip:
      "Fundtap currently operates in New Zealand and Australia only. We're working on expanding to other regions soon!",
    info: "We'll use this to send you important updates",
    title2: "Sweet! ✅",
    text2: "Let's talk business!",
    text3: "Business name or NZBN",
    tooltip2:
      "Enter your registered business name or New Zealand Business Number (NZBN) to to find your company details",
    paraGph: "Can't find your business? Continue typing to enter it manually.",
    businessText: "Business Type Instructions:",
    mutedLi: [
      "Companies: Enter the company name including the suffix e.g. Ltd, Limited",
      "Trading Trusts: Enter the full trust name as it appears on the trust deed",
      `Sole Traders: Use your legal name "trading as" registered trading name`,
      "Partnerships: Enter the partnership names"
    ]
  },
  step5: {
    title: "Nice one! ✨",
    text1: "Just making sure you're eligible",
    text2: "Home Address",
    tooltipTop: "Your residential address is required for:",
    tooltipLi1: "Identity verification",
    tooltipLi2: "Legal documentation",
    tooltipLi3: "Credit assessment",
    paraGh: "Enter your residential address, not your business address",
    title2: "Great! ✨",
    text3: "Lets add the company directors",
    text4:
      "We'll email each director to verify their identity and get things moving.",
    tooltip2:
      "Why do we need this? To meet AML and KYC requirements, we need to verify all company directors. We’ll notify them when it's their turn to complete their part. Credit and identity checks are required, which may add some processing time.",
    director: "Director",
    addAnother: "Add another director"
  },
  step6: {
    title: "Sweet! ✅",
    text1: "Just making sure you're eligible"
  },
  step7: {
    title: "Almost there! 🚀",
    text1: "Link your accounts for speedy approval and even faster funding",
    text2: "Select your accounting software",
    tooltipTitle: "Connecting your accounting software enables:",
    tooltipsLi: [
      "Instant invoice verification",
      "Automated payment tracking",
      "Real-time funding decisions",
      "Seamless reconciliation"
    ],
    idontUse: "I don't use any of these",
    notice: "Important Notice",
    paragraph:
      "FundTap works with businesses awaiting future repayment. If you don't invoice, we may not be the right fit."
  },
  step8: {
    title: "Final step! 🎯",
    text1: "Please review and confirm the following",
    text2: "Xero Integration",
    text3: "Connect Xero for faster funding",
    zeroTooltip: [
      "Access to Xero Organisation data",
      "Auto-syncing and instant verification",
      "Real-time funding decisions",
      "Automatic payment reconciliation"
    ],
    text4: "Credit Check Authorization",
    text5: "Allow credit and identity checks",
    nexTooltip: [
      "Directors will be notified",
      "Identity verification required",
      "Credit checks will be conducted",
      "All directors must approve"
    ],
    finalBtn: "Complete & Connect",
    terms1: "By continuing, you agree to our ",
    terms2: "Terms",
    terms3: "and",
    terms4: "Privacy Policy"
  },

  back: "Back",
  continue: "Continue",
  pressContinue: "Press Enter to continue"
};

export const login = {
  errorMSG: {
    enterEmail: "Please enter a valid email.",
    enterPassword: "Please enter the password",
    requestError: "Request error:",
    Error: "Error:",
    emailRequired: "Email is required.",
    recaptcha: "Please complete the reCAPTCHA",
    // Shown when the server rejects the reCAPTCHA. Says what happened and names
    // the remedy, rather than passing through the backend's internal tag.
    recaptchaRejected:
      "We couldn't confirm you're not a robot. Please reload the page and try again.",
    profileWarning: "Your account has been temporarily disabled.",
    somethingWrong:
      "Something went wrong while processing your request. Please try again later.",
    enter2FA: "Please enter valid 2FA code",
    emailLong: "Email is too long"
  },
  mainTitle1: "Join",
  mainTitle2: "FundTap ",
  mainTitle3: "Today",
  text1p1: "“",
  text1p2:
    "I honestly wish I used FundTap years ago - this is precisely the style of financing my business needed to assist with cash flow ",
  text1p3: "with minimal risk compared to conventional business lending.”",

  text2p1: "Mitchell Musarra",
  text2p2: "MJWebs - Research-driven software development",
  loginBox: {
    subH2: "Log In",
    emailText: "Email address",
    passwordText: "Password",
    havingTrouble: "Having trouble with your 6 digit code?...",
    setupCode: "to setup again your 6 digit code.",
    forgotBTN: "Forgot password?",
    verifylogin: "Verify Log in",
    signUp: "Sign up",
    scanQR:
      "Scan the QR code and enter 6 digit code to your Google authentication app",
    verifyEmail: "Verify your Email",
    onetimepass: "Click the button to be sent a one-time password"
  }
};

export const signup = {
  errors: {
    firstnameErr:
      "First name may contain only letters, spaces, hyphens, apostrophes and full stops.",
    lastnameErr:
      "Last name may contain only letters, spaces, hyphens, apostrophes and full stops.",
    startnumber: "Phone number cannot start with 0",
    numberRequired: "Number is required",
    passRequired: "The password field is required."
  },
  passValidation: {
    rule1: "Password should be at least 8 characters.",
    rule2: "Password should contain at least one digit.",
    rule3: "Password should contain at least one capital letter.",
    rule4: "Password should contain at least one special character.",
    rule5: "Password should contain at least one lowercase letter."
  },
  signupBox: {
    heading: "Get paid without the wait.",
    subheading: "Free to set up, with no lock-in and no obligation to fund.",
    submitButton: "Create free account",
    submitting: "Creating account…",
    subH2: "Sign up for a free account",
    firstname: "First name",
    lastName: "Last name",
    emailAddress: "Email address",
    phoneNumber: "Phone number",
    phoneOkay: "Phone number is okay",
    createPass: "Create Password",
    emailError: "Click the button to be sent a on-time password",
    verifyMymail: "Verify my email"
  },
  emailOtp: {
    heading: "Confirm your email",
    subheading: "Enter the 6-digit code we sent to",
    label: "Verification code",
    verifyButton: "Confirm and create account",
    verifying: "Checking code…",
    creating: "Creating account…",
    resend: "Resend code",
    resending: "Sending…",
    resent: "A new code is on its way.",
    changeEmail: "Change email address",
    required: "Enter the 6-digit code from your email",
    sendFailed: "We could not send the code. Please try again.",
    verifyFailed: "We could not check that code. Please try again."
  },
  getFundingBtn: "Get Funding"
};

export const overdueRE = {
  main_title: "Overdue Report",
  subH2: "Overdue Report as on",
  filter: {
    reportType: "Report Type:",
    startDate: "Start Date:",
    endDate: "End Date:",
    filterBtn: "Filter:",
    forDownload: "For download:"
  },
  overdueModal: {
    title: "Invoice Details"
  },
  modalTable: {
    msgError: "Error loading sales users:"
  },
  rowItems: {
    item1: "Completed",
    item2: "Funded",
    item3: "Processing",
    item4: "Pending",
    item5: "Approved",
    item6: "Outstanding",
    item7: "Not Approved",
    item8: "Unrecoverable",
    item9: "In Default",
    item10: "No AML",
    item11: "Cust Not Require",
    item12: "Archived",
    item13: "Pre Approved",
    item14: "Incorrect Contact Details",
    item15: "Not Invoicing",
    item16: "Test Account",
    item17: "Overdue",
    item18: "Customer DD",
    item19: "All"
  }
};

export const pagination = {
  previous: "Previous",
  page: "Page",
  next: "Next",
  gotoPage: "Go to page:",
  show: "Show",
  saveContinue: "Save & Continue"
};

export const monthlyCommison = {
  mainTitle: "Monthly Sales Commission Report",
  subH2: "Monthly Sales Commission Report",
  filter: {
    errData: "Error fetching data:",
    viewType: "View Type :",
    periods: "Periods :",
    selectCountry: "Select Country :",
    selectLead: "Select Sales Lead :",
    dataType: "Select Data Type:"
  },
  tooltipList: [
    'Total Quoted Fee of Invoices "Funded" in this time period',
    `Average Quoted Fee of invoices "Funded" per customer. = Future Revenue / Customers`,
    `Commission Quoted Fee of invoices "Funded" per customer. = Fee till due date*referral sales lead percentage/100`
  ],
  modal: {
    title: "Invoice Details"
  },
  modaltable: {
    error: "Error loading sales users:"
  },
  emailModal: {
    title: "Details of Email Content Sent to Referral Partner",
    table: {
      th2: "All Time",
      th3: "Commission All Time"
    }
  }
};

export const aiData = {
  msg: "Invoice downloaded successfully",
  msg2: "Failed to download invoice",
  mainTitle: "Ai data",
  btnGrps: {
    btn1: "AI Training Data",
    btn2: "Train AI Model",
    btn3: "AI Training Data_New Calc",
    btn4: "Download Invoices",
    btn5: "FundTap Credit Score Data",
    btn6: "Download Debtor Invoces Report"
  }
};

export const aiReportData = {
  processing: "Processing...",
  updatedPrefix: "Updated",
  fetchError: "Error fetching report status.",
  reportStarted: "Report generation started",
  spinningClass: "spinning"
};

export const customerRepoDtls = {
  main_title: "Customer Details Report",
  table: {
    error: "Error loading sales users:"
  },
  modal: {
    error: "Error fetching data:",
    title: "Download Filter"
  },
  filter: {
    title: "Customer Filter",
    tooltip:
      "All (all customers), Funds Outstanding (all customers with any outstanding invoices i.e. 'Funded', 'Due', 'Overdue' or 'InDefault'), Approved (all customers with status 'Approved'), Transacted (all customers that we have ever funded an invoice for)",
    selectCountry: "Select Country :"
  },
  errMsg: {
    item1: "No customer report found.",
    errorStatus: "error"
  }
};

export const platformPartner = {
  mainTitle: "Platform Partner API management",
  subH2: "Platform Partner",
  addBtn: "Create Platform Partner",
  errorMSG: {
    err1: "Error loading Platform Partner Api:"
  },
  create: {
    title: "Create Platform Partner",
    errMsg: {
      nameErr: "This Name field is required.",
      ipErr: "This IP Address field is required.",
      webhookErr: "This Webhook URL field is required."
    },
    name: "Name",
    ip: "IP address",
    webhookURL: "Webhook URL",
    webhookHeaders: "Webhook additional headers"
  },
  edit: {
    title: "Edit Platform Partner",
    errMsg: {
      err1: "Error fetching Platform Partners"
    },
    acctoken: "Access token",
    webhookToken: "Webhook token"
  },
  table: {
    errMsg: {
      delete: {
        err1: "Delete Platform Partner",
        err2: "Are you sure you want to delete this Platform Partner?",
        err3: "Platform Partner deleted successfully"
      },
      archive: {
        err1: "Archive Platform Partner",
        err2: "Are you sure you want to archive this Platform Partner?",
        err3: "Platform Partner Archived successfully"
      },
      restore: {
        err1: "Restore Platform Partner",
        err2: "Are you sure you want to restore this Platform Partner?",
        err3: "Platform Partner restore successfully"
      }
    }
  }
};

export const buttonName = {
  create: "Create",
  copy: "Copy",
  update: "Update",
  upload: "Upload",
  cancel: "Cancel",
  download: "Download",
  close: "Close",
  loading: "Loading...",
  wait: "Wait...",
  sendEmail: "Send Email",
  export: "Export",
  exporting: "Exporting...",
  send: "Send",
  submit: "Submit",
  seeLess: "See Less",
  seeMore: "See More",
  email: "Email",
  agree: "I Agree",
  excel: "EXCEL",
  pdf: "PDF",
  showOnScreen: "Show On Screen",
  apply: "Apply",
  register: "Register",
  saveChanges: "Save Changes",
  save: "Save",
  sendQuestion: "SEND QUESTIONS",
  sendQuestion1: "Send Question",
  wrireAnswer: "WRITE ANSWERS",
  wrireAnswer1: "Write Answer",
  uploadLater: "Upload Later",
  uploadFile: "Upload file",
  sendLink: "Send link",
  demoInvoice: "Submit Demo Invoice",
  Decline: "Decline",
  ReviewDoc: "Review Document",
  Refresh: "Refresh",
  generate: "Generate",
  duplicate: "Duplicate",
  addOwner: "Add Owner",
  saving: "Saving...",
  continue: "Continue",
  reminder: "Send reminder",
  loadingWait: "Downloading",
  pleaseWait: "Please wait...",
  notRequired: "Not Required",
  completed: "Completed",
  awaiting: "Awaiting...",
  signedByOthers: "Signed by others"
};

export const checklist = {
  errors: {
    addQuestion: "Please enter a question",
    failedAddQuestion: "Failed to update question",
    selectQuestion: "Please select question",
    emailSelect: "Please select email address",
    answerError: "Please enter answer",
    fileDownload: "File downloaded successfully",
    creditBlank: "Credit Limit cannot be blank.",
    blankAmount: "Amount cannot be blank",
    extraAmount: "Amount must not exceed $300,000",
    amountUpdated: "Amount updated successfully",
    noPayment: "No payment file has been created for this invoice."
  }
};

export const statementModal = {
  feeAdjustment: {
    additionalCostDetails: "Additional Cost Details:",
    date: "Date",
    feeAdjustToday: "Fee Adjust Today",
    comment: "Comment",
    total: "Total",
    totalAdditionalCosts: "Total Additional Costs:"
  },
  totalOwing: "Total Owing:"
};
export const dashboard = {
  invoiceTabName: "Invoices",
  commentToast: {
    updateSuccessMessage: "Invoice comment updated successfully",
    updateErrorMessage: "Failed to update invoice comment."
  },
  dashboardTable: {
    quotesErrorMessage: "No quotes found."
  },
  buttonsGroup: {
    advance: "ADVANCE",
    data: "DATA",
    customerStatement: "CUSTOMER STATEMENT"
  },
  repayDateAlert: {
    title: "Change Repay Date",
    alertSize: "alert-xl"
  },
  successModal: {
    title: "AI SCORES",
    message: "Successfully generated AI SCORES"
  },
  advanceAlert: {
    title: "Payment create and Status Change",
    subTitle: "Invoice is not in approved status!",
    subTitle_1: "Customer is not yet approved!",
    subTitle_2: "Direct debit approval is not completed by user!",
    message: "Are you sure you want to create payment and change the status?",
    message_1: "Do you want to Approve the customer?",
    message_2: "Direct debit approval is not completed by the user",
    message_3: "Do you want to complete direct debit for this customer?",
    notApproved:
      "Please ensure the invoices are in approved status before generating the bank file."
  },
  invoiceDatatable: {
    performanc: "Performance Score",
    approvel: "Approval Score",
    decision: "Decision",
    schedule: "Scheduled Status",
    repayDate: "Repay Date",
    dueDate: "Due Date *",
    accStatus: "Acc. Sys. Status",
    sent: "Sent",
    invoNo: "Invoice Number",
    dateFunded: "Date Funded",
    Comments: "Comments",
    customer: "Customer"
  },
  cusStatementModal: {
    title: "Customer Statement",
    selectCustomer: "Select a Customer",
    selectInvType: "Select InvoiceType",
    feeDate: "Fee Date",
    startDate: "Start Date",
    endDate: "End Date",
    notDue: "As at REPAY DATE if not due",
    selectedInv: "You are selected invoice are:",
    text1: "Please make payment to our bank account below and",
    text2: "add the FT Number/s as the payment reference:",
    businessName: "Seascape (2010) Limited t/a Fundtap"
  },
  errorValidation: {
    startDateError: "Start Date cannot be after End Date.",
    customerValid: "Customer is required.",
    invValid: "Invoice Type is required.",
    feeDateValid: "Fee Date is required.",
    startDateValid: "Start Date is required.",
    endDateValid: "End Date is required."
  },
  PaymentHistoryModal: {
    title: "Payment History details"
  }
};

// toast messages
export const invalidToastContent = {
  message: "Invalid",
  status: "error"
};
export const successToastContent = {
  message: "Successfully updated!",
  status: "success",
  danger: "danger"
};
export const userStatusAction = {
  title: "Status Change",
  subH2: "Are you sure you want to change the status?",
  blankData: "",
  fundedToApprovedTitle: "Invoice Already Funded",
  // fundedCount of the selectedCount selected invoices are Funded.
  fundedToApprovedMessage: (fundedCount, selectedCount) => {
    const one = fundedCount === 1;
    let subject;
    if (selectedCount === 1) {
      subject = "The selected invoice is";
    } else if (fundedCount === selectedCount) {
      subject = `All ${selectedCount} selected invoices are`;
    } else {
      subject = `${fundedCount} of the ${selectedCount} selected invoices ${one ? "is" : "are"}`;
    }
    return `${subject} already Funded. Changing ${one ? "it" : "them"} back to Approved does not reverse the payment, and the invoice records may no longer match. Select Change It Anyway to continue, or Cancel to keep the current status.`;
  }
};
export const paymentArchivedAction = {
  title: "Archived",
  subH2: "Are you sure archive payment?"
};

// filter component text and tooltip
export const filterComponent = {
  statusSort: "Status Sort :",
  customerStatusText: "Customer Status :"
};

export const monthlyLending = {
  mainTitle: "Monthly Lending Report",
  subH2: "Select Months",
  filter: {
    title: "Select Years:",
    selectCountry: "Select Country:",
    all: "All",
    nz: "NZ",
    au: "AU"
  },
  view: {
    title: "View:",
    cumulative: "Cumulative",
    perDay: "Per Day"
  },
  summary: {
    monthToDate: "Month to date",
    total: "Total funded",
    biggestDay: "Biggest day",
    averagePerDay: "Avg per day",
    day: "Day",
    empty: "—"
  },
  dailyTable: {
    title: "Total funded per day",
    day: "Day",
    total: "Total funded",
    empty: "—"
  }
};

export const IndustryReport = {
  mainTitle: "Industry Report",
  table: {
    error: "Error loading Report:"
  },
  filter: {
    error: "Error fetching data:",
    viewTye: "View Type :",
    periods: "Periods :",
    selectCountry: "Select Country :",
    selectDataType: "Select Data Type :"
  },
  modal: {
    title: "Invoice Details"
  },
  customerType: "Customer Type",
  classification: "Industry Classification"
};

export const kpiReport = {
  main_title: "Monthly KPI Report",
  errMsg: "Error loading kpi Report:",
  tooltipTexts: {
    "Paid Form Leads": "# Count Form PipeDrive Leads",
    "Linked Accounting":
      '# of new "Signed up" customers that linked their accounting system (% of Signed-up)',
    "Submitted Invoice":
      '# of new "Signed up" customers that submitted an invoice (% of Signed-up)',
    Preapproved:
      "# count any customers that move into state “preapproved” during that month",
    Customers: '# of customers with at least 1 "Funded" invoice',
    New: '# of new "Signed up" customers with at least 1 "Funded" invoice. (% of Signed up) [% of Submitted Invoice]',
    "Preapproved Funded":
      "# count customers that move from state “preapproved” to “approved” during that month",
    Returning: '# of existing customers with at least 1 "Funded" invoice',
    "Not Transacted_Approved":
      '# of existing customers (at least 1 "Funded" invoice in the past) that we did not fund in this time period.',
    Invoices: '# of invoices "Funded" in this time period',
    "Lending ": '$ value of amount advanced for all invoices "Funded"',
    "Lending/Customer":
      "Average Lending per customer in this time period. = Lending / Customers",
    "Ave. Lending":
      'Average Lending per invoice "Funded". = Lending / Invoices',
    "Net Interest Margin":
      "Net Interest Margin = (Revenue - Interest costs) / Average Loan Book",
    '"Completed" Customers':
      '# of customers with at least 1 "Completed" invoice',
    '"Completed" Lending':
      '$ value of amount advanced for all invoices "Completed"',
    "Ave. Days_When Completed":
      'Average Days for all invoices "Completed" in the time period.',
    "Ave. Days_When Funded":
      "Average Days for Invoices FUNDED in the time period. Days are measured as the completed date if “Completed”. If the invoice is still outstanding, days are measured as the Repay Date if a future repay date or today’s date if the Repay Date is in the past.",
    "Average LTV":
      'Total Fees for all invoices "Completed" / # of customers with at least 1 "Funded" invoice. Cumulative i.e. calculated up to the specificed time period.',
    "Average LT Lend":
      'Total Lending for all invoices "Completed" / # of customers with at least 1 "Funded" invoice. Cumulative i.e. calculated up to the specificed time period.',
    "Signed-up": "# Signed-up in this time period",
    "New Clients":
      "Total number of New Clients from Referrals funded that month",
    "NZ Funded": "$ amount of invoices funded to NZ customers",
    "NZ Share": "% share of NZ funded invoices"
  },
  filter: {
    errMsg: "Error fetching data:",
    viewTye: "View Type :",
    period: "Periods :",
    selectCountry: "Select Country :",
    selectState: "Select State :",
    referral: "Referral :",
    referralType: "Referral type :",
    selectSalesLead: "Select Sales Lead :",
    withPercent: "With % :"
  },
  inVcsModal: {
    title: "Invoice Details"
  },
  customerModal: {
    title: "Customer details"
  },
  kpiGraphModal: {
    title: "New and Returning Graph Report"
  },
  referralModal: {
    title: "Partner details"
  }
};

export const ltvReport = {
  mainTitle: "LTV Report",
  filter: {
    country: "Country :",
    customer: "Customers :",
    salesLead: "Sales Lead :",
    refParter: "Referral Partner :",
    asDate: "As at date :"
  },
  downloadModal: {
    title: "Download Filter"
  },
  table: {
    errMsg: "Error loading data:"
  },
  invModal: {
    title: "Invoice Details"
  }
};

export const paymentReport = {
  mainTitle: "Current Payments Report",
  subH2: "Payments Report as on",
  startDate: "Start Date:",
  endDate: "End Date:",
  filter: "Filter:",
  status: "Status:",
  showArchive: "Show Archive",
  syncZero: "Sync Xero",
  inProgress: "In Progress"
};

export const emailPromotion = {
  mainTitle: "Email Promotion",
  sendEmail: "Send Email for Promotion",
  mailAdress: "E-mail Address",
  lastText:
    " use ',' for multiple email ids like ( abc@gmail.com,def@gmail.com )",
  sendBtn: "Send"
};

export const customerDeviceReport = {
  mainTitle: "Customer Device Report",
  subH2: "Customer Device Report",
  filter: {
    reportType: "Customer Filter",
    colon: ":",
    selectDevice: "Select Device:",
    startDate: "From:",
    endDate: "to:"
  },
  tooltip: {
    message:
      "All (all customers), Funds Outstanding (all customers with any outstanding invoices i.e. 'Funded', 'Due', 'Overdue' or 'InDefault'), Approved (all customers with status 'Approved'), Transacted (all customers that we have ever funded an invoice for)"
  }
};

export const reffPartner = {
  title1: "Partner Management",
  title2: "Partner Report",
  title3: "Monthly Reporting",
  title4: "Monthly Commission Report",
  partnermanage: {
    pageTitle: "Referral Partner Management",
    allBtn: "All Referral Partners",
    createBtn: "Create Referral Partner",
    table: {
      alert: {
        item1: "Delete Referral Partner",
        item2: "Are you sure you want to delete this Referral Partner?",
        item3: "Referral Partner deleted successfully",
        item4: "Failed to delete referral partner.",
        item5: "Copied successfully!",
        item6: "Failed to copy the URL.",
        item7: "Partner URL not found."
      },
      errMsg: {
        item1: "No referral partners found."
      },
      filterText: "Partner Type",
      tooltip: {
        customer: "Customer",
        edit: "Edit",
        duplicate: "Duplicate",
        delete: "Delete"
      },
      financeBroker: "Finance Brokers",
      platform: "Platform"
    },
    detailsModal: {
      pageTitle: "Customer details",
      th1: "Customer",
      th3: "Demo INC",
      th4: "demoaccount12@mailinator.com"
    },
    mailSendModal: {
      commisonText: "FundTap Statement of Account",
      discountLi1: "Commission and Client Discounts",
      discountLi2: "Commission Payments",
      discountLi3: "Client Discounts",
      showClientTypeLi1: "Only Transacting",
      showClientTypeLi2: "Only Current Transacting",
      showClientTypeLi3: "All clients",
      errMsg: {
        item1: "The Subject field is required.",
        item2: "Mail Sent Successfully"
      },
      pageTitle: "TestRef Per",
      month: "Month:",
      date1: "Jun-24",
      date2: "May-24",
      date3: "Apr-24",
      date4: "Mar-24",
      discountText: "Show Discounts Table:",
      showDiscount: [
        "Commission and Client Discounts",
        "Commission Payments",
        "Client Discounts"
      ],
      showClientType: "Show Client Type",
      showClient: [
        "Only Transacting",
        "Only Current Transacting",
        "All clients"
      ],
      text1: "Hi TestRef",
      text2: "Thanks for working with us. We really appreciate it!",
      text3: "We have made payment of",
      text4: "$5.68",
      text5: "to your account today:",
      text7:
        "Thanks for referring clients to FundTap. We always appreciate the business!",
      commisionTable: {
        title: "COMMISSION PAYMENTS:",
        th1: "Clients",
        th2: "Avg. Days",
        th3: "Commission",
        th4: "Commission All Time",
        th5: "All Time",
        th6: "July",
        tr1: "FundTap",
        tr2: "27",
        tr3: "$5.68",
        tr4: "$11.36",
        tr5: "TOTAL",
        tr6: "$11.36",
        dontHesitate:
          "Don’t hesitate to get in contact if you have any questions or to discuss how FundTap can solve your clients cash flow problems.",
        yourClient: "Your clients can sign up for free here:",
        muchAppctd: "Much appreciated",
        theFundtapTeam: "The FundTap Team"
      },
      discountTable: {
        title: "CLIENT DISCOUNTS:"
      },
      editorSec: {
        label1: "Editor section:",
        label2: "Send to:",
        label3: "Subject:",
        sendMailBtn: "Send Email"
      }
    },
    GocardLessInfoModal: {
      text1: `That's it! All done. Our team will be in contact shortly to
              get funding sorted. If you have questions in the meantime,
              don't
              hesitate to get in contact with us.`
    }
  },
  partnerReport: {
    pageTitle: "Referral Partner Monthly Report",
    timePeriod: "Time period",
    dateRange: "Date Range",
    monthlyRepModal: {
      modalTitle: "Referral Report"
    }
  },
  monthlyReport: {
    pageTitle: "Referral Partner Monthly Report",
    emailBtn: "Email Now",
    selectMonth: "Select Month",
    referrer: "Referrer",
    referralCode: "Referral Code",
    person: "Person",
    total: "Total",
    pleaseSelect: "Please select a referral partner first."
  },
  monthlyCommReport: {
    pageTitle: "Monthly Commission Report",
    createBtn: "Create Payment ",
    month: "Month",
    markPaid: "Mark As Paid",
    table: {
      alertMsg1: "Are you sure?",
      alertMsg2: "Do you want to proceed with this action?",
      errmsg1: "Invalid password",
      errmsg2: "InUpdated data:",
      total: "Total",
      missingBankAccount:
        "Missing bank account number — excluded from the commission payment export"
    },
    commisonModal: {
      pageTitle: "Breakdown of Fees and Trail Commissions.",
      th1: "FT Number",
      th2: "Customer",
      th3: "Funded Date",
      th4: "Completed Date",
      th5: "Fees",
      th6: "Commission",
      tr1: {
        td1: "100744",
        td2: "company",
        td3: "17-May-2024",
        td4: "31-May-2024",
        td5: "50.58",
        td6: "30"
      },
      tr2: {
        td1: "Fees to Commission",
        td2: "Ratio:",
        td3: "1.69",
        td4: "$50.58",
        td5: "$30.00"
      }
    },
    monthlyCommModal: {
      mailUseState: "testpartner@example.com",
      commisonState: "FundTap Commission",
      msg: {
        item1: "The Send field is required.",
        item2: "The Subject field is required.",
        item3: "Mail Send Successfully",
        item4: "vvv"
      },
      pageTitle: "TestPartner2",
      pageTitle1: "Details of Email Content Sent to Referral Partner",
      partnerHi: "Hi",
      partnerDynamicName: "{{Dynamic Name}}",
      partnerDynamicAmmount: "{{Dynamic Amount}}",
      partnerClientName: "{{Client Name}}",
      partnerAmmount: "{{Amount}}",
      partnerName: "Hi",
      commisionTable: {
        th1: "Partner",
        th2: "Advanced",
        th3: "Avg. Days",
        th4: "Commission",
        th5: "Commission All Time",
        tr1: {
          td1: "TestPartner2",
          td2: "FundTap",
          td3: "$1,000.00",
          td4: "27",
          td5: "$5.68",
          td6: "$11.36"
        },
        tr2: {
          td1: "TOTAL",
          td2: "$1,000.00",
          td3: "$5.68",
          td4: "$11.36"
        }
      },
      signupText: " {{Dynamic Url}}",
      signupUrl: "https://secure.fundtap.co/"
    },
    passModal: {
      pageTitle: "Enter Password",
      subH2: "Please enter your password to proceed"
    },
    dateChangeModal: {
      pageTitle: "Select Date Paid",
      date: "DATE:",
      dateupdate: "Date Update"
    },
    errMsg: {
      item1: "Are you sure you want to mark this report as paid?",
      item2: "Please Select atleast one partner"
    }
  },
  partnerSignup: {
    para1:
      "The difference between going directly to the bank and using FundTap was huge. No time-wasting, no lengthy applications – just approval and results. Partnering with FundTap was one of the best decisions I have evermade. With the funding I got I now have the flexibility to grow the business exactly the way we want."
  }
};

export const createReffPartner = {
  errmsg: {
    item1: "The Phone Number field is required.",
    item2: "Phone number must contain only numeric characters.",
    item3: "Email field is required.",
    item33:
      "One or more email addresses are invalid. Please enter valid emails separated by commas.",
    item4: "The Name field is required.",
    item5: "Name must contain only alphabetic characters and spaces.",
    item6: "The country field is required.",
    item7: "The Referral code field is required.",
    item8: "The Bank account field is required.",
    item9: "Bank account number can only contain numbers and letters.",
    item99: "Bank account number must be between 14 and 16 characters.",
    item10: "Bank account number must be between 13 and 16 characters.",
    item11: "The Listing website field is required.",
    item12: "The Upfront field is required.",
    item13: "The Trail field is required.",
    item14: "The Upfront client discount field is required.",
    item15: "The Ongoing client discount field is required.",
    item16: "The Referral organisation field is required.",
    item17: "The Trail period field is required.",
    item18: "Canvas is empty",
    item19: "No bank account was found for this organization.",
    item20: "Please crop the image before submitting.",
    item21: "Resource not found.",
    item22: "Unable to submit form. Check your network connection.",
    item23: "Only '@','-','_' allowed in Referral Code."
  },
  mainTitle: "Referral Partner Management",
  content: "Create Referral Partner",
  subH2: "All Referral Partners",
  referralPerson: "Referral Person",
  emailText:
    "Use ',' for multiple email ids like ( abc@gmail.com,def@gmail.com )",
  phone: "Phone",
  country: "Country",
  state: "State",
  enterState: "Enter State",
  referralOrg: "Referral Organisation",
  selectOrg: "- Select Organisation -",
  OrgLead: "Organisation Lead",
  referralCode: "Referral Code",
  partnerUrl: "Partner URL (old)",
  partnerSignupUrl: "Partner Sign Up URL",
  partnerSignupUrlText:
    "It will be better to copy the code before updating the page",
  customerFunded: "Email when Customer Funded",
  reffPartnerType: "Referral Partner Type",
  bankAcc: "Bank Account",
  bankAccText: "use organisation bank account?",
  reffsalesLead: "Referral Sales Lead",
  selectSalesLead: "- Select Sales Lead -",
  showReffList: "Show Referral Listing",
  reffListWebsite: "Referral Listing Website",
  reffListPage: "Referral Listing Page description",
  commAndDiscount: "Commission & Discount",
  upfront: "Upfront",
  upfrontTpe: "Upfront Type",
  trail: "Trail",
  trailType: "Trail Type",
  trailPeriod: "Trail period (Months)",
  upfrontClientDscount: "Upfront Client Discount",
  upfrontClientDscountType: "Upfront Client Discount Type",
  ongoingClientDiscnt: "Ongoing Client Discount",
  feeText: "% of fee",
  shortDesc: "Short Description",
  image: "Image",
  cropBtn: "Crop",
  idealDimension: "Ideal Dimensions 920x200",
  defaultValues: {
    partnerType: "Bookkeeper",
    upfrontType: "% of credit limit",
    trailType: "% per year",
    upfrontClientDiscountType: "% of fee"
  },
  editReferralCode: "Edit Referral Code"
};

export const duplicateReffPartner = {
  errMsg: {
    item1: "Error fetching referral user:",
    item2: "There are invalid emails."
  },

  mainTitle: "Referral Partner Management",
  content: "Add Duplicate Referral Partner",
  createdby: "Created By",
  createdAt: "Date Created"
};

export const EditReffPartner = {
  alert: {
    title: "Delete Refwrral Partner",
    subText: "Are you sure you want to delete this sales lead?"
  },
  errMsg: {
    item1: "Error fetching referral partner:",
    item2: "Referral code is required"
  },
  subH2: "Edit Referral Partner",
  salesLeadLog: "Referral Sales Lead Log",
  action: "Action",
  toolTips: {
    edit: "Edit",
    delete: "Delete"
  },
  editReffModal: {
    title: "Edit Referral Partner Sales Lead",
    salesLead: "Sales lead:",
    choose: "--Choose--",
    startDate: "Start Date:",
    endDate: "End Date:",
    updatebtn: "Update Sales lead"
  },
  addReffModal: {
    title: "Add Referral Partner Sales Lead"
  },
  editReferralText_1: "This referral code is used by",
  editReferralText_2: "customers, you cannot change it.",
  partnerPortal: {
    inviteBtn: "Invite to Partner Portal",
    inviteSending: "Sending...",
    inviteSuccess:
      "Partner invite sent — they'll receive a password setup email.",
    inviteError: "Failed to send invite.",
    loginAsBtn: "Login as partner",
    loginAsSwitching: "Switching...",
    loginAsError: "Failed to log in as partner.",
    provisionTitle: "Create a portal login?",
    provisionText:
      "This partner has no portal login yet. Continuing creates one so you can preview their portal. No invite email is sent."
  }
};

export const fieldValidation = {
  required: "This field is required.",
  enterValidNumber: "Please enter a valid number",
  dateError: "Please select fee date."
};

export const InvoiceDetails = {
  fundtapInformation: {
    title: "FUNDTAP INFORMATION",
    ftNo: "FT NO.",
    status: "STATUS",
    documents: "Documents",
    overduePredict: "FT CREDIT SCORE",
    alerts: "ALERTS",
    comment: "INVOICE COMMENT",
    adminUpload: "AdminUpload",
    errors: {
      invalidId: "Invalid invoice ID",
      empty: "Received an empty PDF file. Please check with support.",
      successDownload: "Quote downloaded successfully!",
      noInvoice: "No demo invoices found for the given user."
    }
  },
  paymentSection: {
    mainTitle: "PAYMENTS",
    subH2: "ORIGINAL DUE DATE",
    originalDueDate: "Original Due Date",
    repayDate: "Repay Date",
    clientExpectedPaymentDate: "Client Expected Payment Date",
    paymentComment: "Payment Comment",
    typeCmntProp: "Payment",
    totalWing: "Total Owing",
    dateRepaid: "Date Repaid",
    totalWingPaymentDate: "TOTAL OWING (REPAY DATE)",
    paymentTable: {
      total: "Total Payment"
    },
    paymentModal: {
      title: "ADD PAYMENT",
      paymentDate: "Payment Date:",
      rePaymentDate: "Repayment Date",
      amount: "Payment Amount:",
      paymentStatus: "Payment Status:",
      xeroStatus: "FT ENTERED - Paid",
      updatePayment: "UPDATE PAYMENT",
      th1: "DATE:",
      th2: "AMOUNT:",
      th3: "TYPE:",
      th4: "XERO STATUS",
      th5: "GOCARDLESS STATUS"
    },
    passwordContent: {
      title: "Delete Payment",
      subTitle: "Please enter your password to proceed"
    }
  },
  feeSection: {
    title: "FEE",
    quotedFee: "QUOTED FEE",
    feeToday: "FEE (today)",
    repayFee: "REPAY FEE",
    funded: "FUNDED",
    overdueDate: "OVERDUE DATE",
    pricing: "Pricing",
    feeAddModal: {
      title: "FEE ADJUSTMENT",
      adjustmentAmount: "FEE ADJUSTMENT AMOUNT:",
      date: "DATE:",
      comments: "COMMENT",
      th: "UPDATE FEE ADJUSTMENT",
      th1: "FEE ADJUST REPAY",
      th2: "FEE ADJUST TODAY:"
    },
    passwordModal: {
      title: "Overdue Date Change",
      deleteTitle: "Delete Overdue Date & Fee.",
      sub: "This action will remove the Overdue Fee. Review the Invoice Status if required."
    }
  },
  detailsSection: {
    title: "INVOICE DETAILS",
    customer: "CUSTOMER",
    invNo: "INV NO.",
    debtor: "DEBTOR",
    debtorLastPaid: "DEBTOR LAST PAID",
    invAmount: "INV AMOUNT (OWING)",
    accStatus: "ACC STATUS",
    sent: "SENT",
    dateCreated: "Date Created",
    dateSubmitted: "Date Submitted",
    header: "Payment History details",
    text: " Lorem ipsum dolor sit amet consectetur adipisicing elit.Recusandae at culpa consequatur vero. Ea dolorum accusantium cum id! Autem sit, porro dolorem corrupti quasi dolorum ipsam vero doloremque sed ullam! ",

    btn: {
      download: "Downloading...",
      upload: "Uploading...",
      copy: "Invoice Copy",
      autoDownload: "AUTHORISED",
      manualCheck: "User Entered"
    },
    error: {
      success: "Status refreshed successfully!",
      faield: "Failed to refresh invoice status."
    },
    alert: {
      title: "Update Debtor Name",
      subTitle:
        "Are you certain you wish to proceed with altering the debtor's name?"
    },
    showText: {
      text1: "No"
    }
  },
  feeCalculator: {
    title: "Fee Calculator",
    today: "Today",
    total: "Total",
    feeCalc: "FEE CALC",
    totalOwing: "TOTAL OWING",
    payment: "incls any payments made"
  },
  invoiceLog: {
    title: "INVOICE LOG",
    inTable: {
      event: "Event",
      on: "on",
      ip: "IP:"
    }
  },
  xeroWriteBack: {
    title: "ADMIN XERO WRITEBACK",
    writeBackStatus: "Writeback Status",
    xeroPlaceholder: "Xero invoice ID",
    writeBackLogs: "Admin Writeback Logs",
    refreshTooltipId: "tooltip-refreshWriteback",
    resyncTooltipId: "tooltip-resyncWriteback",
    tooltipPlace: "top",
    Created: "Created:",
    Executed: "Executed:",
    infoMsg: "This process is on hold and will be executed in the background.",
    writeBackIdError: "Enter Xero Invoice ID",
    writeBackUUIdError: "Enter a valid Invoice ID",
    message: "Sync in progress..."
  },
  voidedModalaData: {
    title: "Voided Invoice",
    subTitle: "The invoice is voided or deleted"
  },
  invoceStausChange: {
    content1: "Some Invoices have repayment dates greater than 60 days.",
    content2: "has a repayment date in",
    content3: "days"
  }
};

export const commonErrMsg = {
  item1: "An error occurred while processing the request.",
  item2: "An unexpected error occurred.",
  item3: "An error occurred while toggling verification.",
  item4: "An unexpected error occurred. Please try again.",
  item5: "An error occurred",
  item7: "An error occurred while processing your request.",
  item8: "Invalid password. Try again.",
  item9: "Incorrect password. Please try again",
  item10: "An error occurred:",
  item11: "Error downloading the file",
  item12: "Error updating comment:",
  item13: "Please select at least one data.",
  item14: "Successfully deleted",
  item15: "No link found!",
  item16: "If urgent please",
  item17: "Contact Us",
  item18: "If urgent, please contact us",
  item19: "Incorrect phone number",
  myobSuccess: "Myob Software Connected Successfully",
  reckonSuccess: "Reckon Software Connected Successfully",
  notFoundBook: "Not found list of bookId",
  organisationNotFound:
    "Your organisation was not found. Please connect your Reckon account again.",
  selectMonth: "You can not select future month",
  feeAdjustMent: "Fee adjustment deleted successfully",
  failDemoUser: "Failed to create demo user:",
  failedDocumentCreate: "Failed to generate document",
  referralPartnerSuccess: "Referral partner updated successfully",
  RecaptchaError: "Recaptcha not ready yet",
  reasonSaved: "Reason saved successfully",
  markedReqSuccess: "Marked as required successfully",
  gocardlessSetup: "GoCardless Direct Debit Setup successfully"
};

export const commonText = {
  action: "Action",
  showDetails: "Show Details",
  hideDetails: "Hide Details",
  seeLess: "See Less",
  seeMore: "See More",
  fallbackLoader: "Loading...",
  underProcessing: "Under Processing",
  ago: "ago",
  step1: "0.01",
  dashed: "--",
  yes: "yes",
  no: "no",
  select: "-Select-",
  markNotRequired: "Mark as Required",
  markNotRequiredContent: "Are you sure you want to mark this as not required?"
};

export const tooltips = {
  refreshWriteback: "Refresh Writeback",
  resyncWriteback: "Resync Writeback",
  edit: "Edit",
  add: "Add",
  syncData: "Sync Data",
  sync: "Sync",
  archive: "Archive",
  archived: "Archived",
  delete: "Delete",
  setasDefault: "Set as Default",
  default: "Default",
  restore: "Restore",
  deactivate: "Deactivate",
  activate: "Activate",
  referralEmail: "Referral Email",
  sendEmail: "Send Email",
  upload: "Upload",
  unverified: "Unverified",
  unverify: "Unverify",
  verified: "Verified",
  verify: "Verify",
  track: "Track",
  remove: "Remove",
  loginAs: "Login as",
  loginAsUser: "Login as User",
  user: "User",
  view: "View",
  changePassword: "Change Password",
  resend: "Resend",
  refreshAiScore: "Refresh AI Training Data",
  emailPlay: "Email Play",
  emailPause: "Email Pause",
  sendTestSms: "Send Test SMS",
  sendSms: "Send SMS",
  reset: "Reset",
  refresh: "Refresh",
  data: "Data",
  softDelete: "Soft Delete",
  popdoc: "POP Documents",
  quote: "Quote",
  fundingNotice: "Funding Notice",
  generateFunding: "Generate Funding Invoice",
  downloadInvoice: "Download Invoice",
  downloadCreditScoreReport: "Download Credit Score Report",
  refreshDownloadInvoice: "Refresh Download Invoice",
  uploadInvoiceCopy: "Upload Invoice Copy",
  invoiceCopy: "Invoice Copy",
  submitInvoice: "Submit Invoice",
  mailSend: "Mail Send",
  addCorporate: "Add Corporate",
  addDirectorship: "Add Directorship",
  searchCompanyRole: "Search Company Role Entity",
  addProperty: "Add Property",
  propertReport: "Property Report",
  uploadFile: "Upload file",
  anz: "(ANZ)",
  bnz: "(BNZ)",
  searchCreditScore: "Refresh Credit Score",
  addFee: "Add Fee",
  editDebtor: "Edit Debtor",
  debtorPaidHistory: "Debtor Paid History",
  accStatusRefresh: "ACC Status Refresh",
  addpayments: "Add Payments",
  showSaleslead: "Show Sales Leads",
  countryInfo: "Country Information",
  industryInfo: "Industry Information",
  validateContact: "Validate Contact Number",
  gocardlessTooltip: "Gocardless Status Update",
  mandateRemove: "Mandate Remove",
  pricingHistory: "Pricing Plan History",
  uploadCreditReport: "Upload Credit Report",
  searchFinancing: "Search Financing Statement",
  creditLimitHistory: "Credit Limit History",
  getArApData: "Get AR/AP Data",
  getFinacialReport: "Load Financial Report",
  showLessDetails: "Show less details",
  showMoreDetails: "Show more details",
  expandSidebar: "Expand Sidebar",
  collapseSidebar: "Collapse Sidebar",
  refreshBankAccounts: "Refresh Bank Accounts",
  collapseRowDetails: "Collapse row details",
  expandRowDetails: "Expand row details",
  expandSidebarOptions: "Show  Options",
  collapseSidebarOptions: "Hide  Options",
  downloadPdf: "Download PDF"
};

export const pricingPlan = {
  tab2Title: "Bulk Change Pricing Plan",
  errMsg: {
    item2: "Pricing Plan deleted successfully",
    item3: "Failed to delete Pricing Plan."
  },
  alert: {
    item1: "Delete Plan",
    item2: "Are you sure you want to delete this plan?",
    item3: "Archive Plan",
    item4: "Are you sure you want to archive this plan?"
  },
  pricingtable: {
    plantype: "Pricing Plan Type",
    all: "All",
    standard: "Standard",
    variable: "Variable",
    riskVariable: "Risk-based Variable",
    standardPricing: "Standard Pricing Section",
    riskBasedPlan: "Risk-based Variable Pricing Section",
    edit: "Edit",
    createSection: "Create Section",
    checkRisk: "Check Risk"
  },
  bulkChange: {
    customerStatus: "Customer Status:",
    industry: "Industry:",
    accSoftware: "Accounting Software:",
    orgType: "Org Type:",
    country: "Country:",
    propertyOwnership: "Property Ownership:",
    commercialCreditScore: "Commercial Credit Score:",
    pricingPlan: "Pricing Plan:",
    clearFilter: "Clear Filter",
    table: {
      alert: {
        item1: "Pricing Plan Change",
        item2:
          "You are changing the pricing plan. Are you sure you want to proceed?"
      },
      currentPricingPlan: "Current Bulk Pricing",
      selectpricingPlan: "Select Pricing Plan:",
      currentBulkPricing: "Current Bulk Pricing",
      bulkChangeModal: {
        title: "Bulk change pricing plan history"
      },
      passwordModal: {
        errmsg: "Please enter the password",
        title: "Please enter your password to proceed",
        enterPass: "Please enter your password to proceed",
        enterPass1: "Enter your password below to proceed."
      }
    }
  }
};

export const createPricingPlan = {
  errMsg: {
    item1: "Min range must be less than max range",
    item2: "Max range must be greater than min range",
    item3: "This field is required."
  },
  mainTitle: "Pricing Plan Management",
  content: "Create Pricing Plan",
  pricingName: "Pricing plan name",
  standardPricing: "Standard Pricing",
  flatRate: "Flat rate (%)",
  parate: "P.A. rate (%)",
  overdue: "Overdue",
  flatRateAddnl: "Flat rate (%) ( additional )",
  parateAddnl: "P.A. rate (%) ( additional )",
  autoSwithing: "Auto Switching",
  inactive: "Inactive",
  active: "Active",
  triggerForoverdue: "Trigger for Overdue",
  forIndustryType: "For Industry type",
  industryTypeOptions: {
    item1: "- Select -",
    item2: "Trades/Construction",
    item3: "Trades/ConstructionLOW",
    item4: "Consultants",
    item5: "Recruitment",
    item6: "Distributors/Wholesalers",
    item7: "B2B Service Provider",
    item8: "Other"
  },
  accSoftwareoptions: {
    item1: "Xero",
    item2: "QB",
    item3: "Myob",
    item4: "Reckon",
    item5: "Manual Upload"
  },
  orgtype: "Org Type",
  orgtypeoptions: {
    item1: "Partnership",
    item2: "Accounting Practice",
    item3: "Trust",
    item4: "Sole Trader",
    item5: "Company",
    item6: "Limited Partnership"
  },
  country: "Country",
  propertyOwnership: "Property Ownership",
  propertyOptions: {
    item1: "Yes",
    item2: "No",
    item3: "No - but I own other property"
  },
  riskbased: "Risk-based Variable",
  selectGrp: "Select Group",
  selectGrpOptn: "-Select Group Name-",
  minlimit: "Min limit of Risk",
  maxlimit: "Max limit of Risk",
  placeHolder: {
    item1: "4",
    item2: "15"
  },
  variable: "Variable",
  standard: "Standard"
};

export const createPricingPlanGrp = {
  content: "Create Pricing Plan",
  subH2: "Create Plan"
};

export const editPricingPlan = {
  content: "Edit Pricing Plan"
};

export const editPricingPlanGrp = {
  content: "Edit Pricing Plan Group",
  subH2: "Edit Plan"
};

export const editPricingPlanSection = {
  errMsg: {
    item1: "Error fetching Pricing Plan:",
    item2: "Plan updated successfully",
    item3: "There was an error creating the Pricing Plan!",
    item4: "There was an error creating the Pricing Plan. Please try again."
  },
  testPricingPlan: "TestPricingPlan"
};

export const UserManagment = {
  ownerTab: {
    identificationSection: {
      title: "Identification",
      firstName: "First Name",
      middileName: "Middle Name",
      lastName: "Last Name",
      dob: "DATE OF BIRTH",
      personalAddress: "PERSONAL ADDRESS",
      Passport: "PASSPORT",
      ExpiryDate: "Expiry Date",
      DrivingLicence: "DRIVER LICENCE",
      VersionOrState: "VERSION/STATE",
      cardNumber: "CARD NUMBER",
      idCheck: "ID CHECKS",
      idVerification: "ID VERIFICATION",
      isApplyIdMandatory: "Is ApplyId Mandatory",
      isApplyIdMandatoryStatus: {
        true: "Yes",
        false: "No"
      },
      manuallyUpload: "MANUALLY UPLOAD ID",
      comment: "ID COMMENTS",
      typeCmntProp: "Manually_Id_Comment"
    },
    errMsg: {
      item1: "Please select a Agrement Type"
    },
    property: {
      selectPropertyModal: {
        title: "Select Property",
        propertySelect: "Title reference (title description)"
      }
    }
  },
  financialsTab: {
    aiCreditScoreSection: {
      title: "AI & CREDIT SCORE",
      profitPredict: "Profit Predict",
      overduePredict: "Overdue Predict",
      pricingPlan: "PRICING PLAN",
      ftCreditScore: "FT credit score",
      ppAutoSwitching: "PP. AUTO-SWITCHING",
      comment: "COM. CREDIT COMMENT",
      typeCmntProp: "Com_Credit",
      aiCreditModal: {
        title: "FundTap Credit Score",
        invoiceLabel: "Score for this Invoice:"
      },
      passwordModal: {
        title: "Enter Password",
        subTitle: "Please enter your password to proceed.",
        deleteUser: "Delete Customers"
      },
      confirmDelete: "Are you sure you want to delete this credit report?"
    },
    financialsSection: {
      title: "FINANCIALS",
      comment: "FINANCIAL COMMENT",
      typeCmntProp: "Financial",
      arap: "AR/AP",
      recivables: "A. Receivables",
      paybles: "A. Payables",
      debtorCount: "Debtor count",
      revenue: "Revenue",
      profit: "Profit",
      debtorModal: {
        title: "Debtors Information",
        table: {
          Name: "Name",
          Receivable: "Acc. Receivable",
          Payable: "Acc. Payable",
          Outstanding: "Outstanding",
          Overdue: "Overdue"
        }
      }
    },
    finReportSection: {
      title: "FINANCIAL REPORT",
      timePeriod: "TIME PERIOD",
      cashIn: "Cash In",
      cashOut: "Cash Out",
      report: "REPORTS",
      eofyDate: "EOFY DATE",
      jsonFiles: "REPORTS JSON FILES",
      profitTable: {
        profitLoss: "PROFIT & LOSS",
        currentYear: "CURRENT YEAR",
        prevYear: "PREVIOUS YEAR",
        currentMonth: "CURRENT MONTH",
        prevMonth: "PREVIOUS MONTH",
        prev3Month: "PREVIOUS 3 MONTHS",
        current3Month: "CURRENT 3 MONTHS",
        prev6Months: "PREVIOUS 6 MONTHS",
        current6Months: "CURRENT 6 MONTHS",
        revenue: "REVENUE:",
        costOfSale: "COST OF SALES:",
        expanse: "EXPENSES:",
        profit: "PROFIT:",
        balSheet: "BALANCE SHEET",
        bank: "BANK:",
        TotalBank: "Total Bank:",
        currAssets: "CURR. ASSETS:",
        totalAssets: "TOTAL ASSETS:",
        currLiablities: "CURR. LIABILITIES:",
        totalLiablities: "TOTAL LIABILITIES:",
        equity: "EQUITY:",
        currRatio: "CURRENT RATIO",
        fileNameLink: "REPORTS JSON FILES"
      },
      eoefdateText: "1 Apr - 31 Mar",
      selectOption: "Select report data"
    }
  },
  trustCorporateTab: {
    trustAlert: {
      title: "Add Trust",
      subject: "Are you sure you want to add a new trust?",
      icon: "warning"
    },
    trustField: {
      isTrustee: {
        text1: "Is Trustee",
        text2: "a Company?"
      },
      trustee: "TRUSTEE",
      director: "DIRECTOR",
      name: "NAME",
      companyName: "COMPANY NAME",
      firstName: "FIRST NAME",
      lastName: "LAST NAME",
      email: "EMAIL",
      dob: "DOB",
      dateOfBirth: "DATE OF BIRTH",
      address: "Address",
      city: "City",
      zipcode: "Zipcode",
      nzbn: "NZBN",
      companyNo: "Company No.",
      professional: "Professional Trustee"
    }
  }
};

export const toolTipContent = {
  reload: "Reload",
  link: "Link"
};

export const salesLeadText = {
  mainTitle: "Sale Lead management",
  subH2: "Sales Lead People",
  createBtn: "Create Lead Person",
  errMsg: {
    item1: "Delete sales lead",
    item2: "Are you sure you want to delete this sales lead?",
    item4: "Archive sales lead",
    item5: "Are you sure you want to archive this sales lead?",
    item6: "Restore sales lead",
    item7: "Are you sure you want to restore sales lead?",
    item8: "Failed to search sales leads"
  }
};

export const action = "Action";
export const docs = "Docs";

export const addSalesLead = {
  errMsg: {
    item1: "The lead person name must be at least 5 characters.",
    item2: "Name must contain only alphabetic characters and spaces.",
    item3: "Nickname cannot contain special characters or numbers.",
    item5: "Phone number must contain only numeric characters.",
    item6: "The high touch commission rate must be less than 100.",
    item7: "The low touch commission rate must be less than 100.",
    item8: "The referral commission rate must be less than 100.",
    item9: "Phone number already exists",
    item10: "Email already exists",
    item11: "An unknown error occurred"
  },
  mainTitle: "Sale Lead People Management",
  subH2: "Create Sale Lead Person",
  fullName: "Full Name",
  mailAddrs: "Email Address",
  nickName: "Nick Name",
  number: "Contact Number",
  clientCommison: "Direct Client Commission",
  highTouchComsn: "High Touch Commission Rate (%)",
  lowTouchComsn: "Low-Touch Commission Rate (%)",
  referralCommsn: "Referral Commission",
  referralCommsnRate: "Referral Commission Rate (%)"
};

export const editSalesLead = {
  errMsg: {
    item1: "Error fetching sales user:"
  },
  subH2: "Edit Sale Lead Person"
};

export const accSoftwarePage = {
  subheading: "All Accounting Software",
  createBtn: "Create Accounting Software",
  accTable: {
    errMsg: {
      item1: "No icon found for row ID:",
      item2: "Deactivate Accounting Software",
      item3: "Are you sure you want to deactivate this Accounting Software?"
    }
  },
  modal: {
    title: "Connected Users"
  },
  quickBookLogo: "Quick book logo",
  myobLogo: "Myob logo",
  reckonLogo: "Reckon logo",
  xeroLogo: "Xero logo",
  xero: "xero"
};

export const createAccPage = {
  errMsg: {
    item2: "Only image files (JPEG, PNG, GIF) are allowed.",
    item3: "This filed is required",
    item4: "Software name must contain only alphabetic characters and spaces",
    item5: "No file selected"
  },
  softwareName: "Software Name",
  apiBase: "API Base URL",
  authMethod: "Auth Method",
  documentUrl: "Documentation Url",
  icon: "Icon",
  selectedFile: "Selected File:",
  status: "Status",
  active: "Active",
  inactive: "Inactive"
};

export const editAccPage = {
  subheading: "Edit Accounting Software"
};

export const fileDownloadMessages = {
  errors: {
    fileDownloadFailed: "Failed to download report.",
    downloadSuccess: "downloaded successfully",
    downloadFailed: "Download failed. Please try again later",
    uploadFaield: "Upload failed",
    financialPdfReport:
      "Failed to create new financial report! Please reload the page and try again!",
    financialGenerateReport: "Not found generated financial report!",
    noQuotesFound: "No quotes found for the provided criteria."
  }
};

export const lessBelowHundredReport = {
  mainTitle: "Invoice Loans Less Than Hundred",
  subH2: "Invoice Loans Less Than Hundred",
  filter: {
    search: "Search:"
  }
};

export const promoCode = {
  mainTitle: "Promo Code",
  subheading: "Listing Promo Code",
  table: {
    errMsg: {
      item1: "Delete Promo Code",
      item2: "Are you sure you want to delete this promo code?",
      item3: "Promo code deleted successfully",
      item4: "Failed to delete promo code.",
      item5: "no promo code user found",
      item6: "Please select at least one user"
    }
  },
  trackModal: {
    existingCstmrpromo: "Existing Customer Promocode",
    offerTrigger: "Offer Trigger",
    linkWithAcc: "Linked with Account Software",
    submittedInvoice: "Submitted An Invoice",
    fundedInvoice: "Funded An Invoice"
  },
  trackPromoLinkModal: {
    hi: "Hi"
  },
  usageModal: {
    title: "Promo Code Usage",
    subtitle: "Customers who have used this promo code",
    downloadBtn: "Download CSV",
    errMsg: {
      item1: "Unable to load the customers who used this promo code.",
      item2: "Unable to download the promo code report."
    }
  },
  referralEmail: {
    selectpromo: "Select a promocode",
    text1: "Select Existing Customers to email referral offer",
    choose: "Choose.."
  },
  promoReferraEmail: {
    title: "Choose Reward Promo Code and Trigger",
    errMsg: {
      item1: "Please select a promocode",
      item2: "Please select a promo code"
    }
  }
};

export const promoPageAction = {
  allPromoBtn: "All Promo Codes",
  createPromoBtn: "Create Promo Codes"
};

export const createPromocode = {
  mainTitle: "Create Promo Code",
  errMsg: {
    item1: "The Promo Code must be at least 6 characters.",
    item2: "The customer type field is required.",
    item3: "The discount amount field is required when discount is not present."
  },
  promoCode: "Promo Code",
  discount: "Discount",
  title: "Title",
  summary: "Summary",
  purpose: "Purpose",
  applyDiscountTo: "Apply discount to",
  applyDiscountToOpt1: "Apply to lowest value invoice",
  applyDiscountToOpt2: "Apply to all invoices",
  applyDiscountToOpt3: "Apply to highest value invoice",
  applyToCstmr: "Apply to customers",
  applyOncePerCstmr: "Apply Once per Customer"
};

export const editPromoPage = {
  title: "Edit Promo Code",
  subheading: "Edit Promo Code",
  errMsg: {
    item1: "Error fetching promo code:"
  },
  url: "URL"
};

export const promoCodeDirect = {
  errMsg: {
    item1: "After success check!"
  }
};

export const referencePromoCode = {
  errMsg: {
    item1: "Failed to get IP address",
    item2: "Failed to get country from IP",
    item3: "First name should be at least 3 characters",
    item4: "Last name should be at least 3 characters",
    item5: "Please enter a valid email",
    item6: "Phone number cannot be empty",
    item7: "Password should be at least 8 characters.",
    item8: "Password should contain at least one digit.",
    item9: "Password should contain at least one capital",
    item10: "Password should contain at least one special character.",
    item11: "Password should not similar with the current password",
    item13: "Phone number is required",
    item14:
      "Password should be at least 8 characters, contain at least one digit, one capital letter and one special character",
    item15: "Unexpected response from server",
    item16: "Registration error:",
    item17: "An error occurred while registering",
    item18: "Failed to display image"
  },
  text1:
    "FundTap advances you funds against your outstanding invoices. We are specifically designed to solve the cash flow needs of small businesses.",
  text2:
    "Ready to go? Create your free account and explore how FundTap can solve",
  text3: "your Cash Flow problems:",
  createAccbtn: "Create Free Account",
  text4:
    "Got questions? Unsure on anything? We love to talk about all things to do",
  text5: "with Cash Flow for businesses:",
  bookbtn: "Book a time to chat",
  text6: "Why Fundtap?",
  text7:
    " “FundTap has literally removed the stress and sleepless nights from running a business… just a couple of clicks to access as much or as little of our money as we need”",
  text8: "How it works",
  one: "1.",
  text9: "INVOICE",
  text10:
    "Select one or more of your outstanding invoices. FundTap will pay these invoices to you now.",
  two: "2.",
  text11: "APPROVED",
  text12:
    "FundTap reviews and approves the invoices you select and makes payment to you.",
  three: "3.",
  text13: "GET PAID",
  text14: "When your customer pays, you repay FundTap by direct debit.",
  text15: "Simple & quick cash flow solutions",
  text16:
    "FundTap has partnered with a wide variety of industries including trades, manufacturing, recruitment, professional services and import/export amongst others. Often cash flow issues will arise through extended payment terms or the need to purchase supplies in advance of invoice payment for work.",
  text17:
    "We understand the time constraints and cash flow challenges businesses face and how it can halt your business growth, which is why we can advance funds quickly and without hassle to keep you moving forward. Once your debtor pays the outstanding invoice we direct debit your account. Simple as that.",
  text18: "Cash Flow Solution",
  text19:
    "We solve your cash flow problems so you can run and grow your business.",
  text20: "Fast Funds",
  text21:
    "Quick application process. We can have funds in your account in hours.",
  text22: "Simple & Easy",
  text23:
    "No paperwork. Link your accounting system to get funding at the click of a button.",
  text24: "Innovative Solution",
  text25:
    "You are in control. We do things differently to make funding simple for you.",
  text26: "Customer success stories",
  text27:
    "How YUM diversified their product range and achieved cost savings with FundTap",
  text28:
    " “We love the convenience and accessibility of FundTap. It’s simple which is really nice and has enabled us to do things we wouldn’t otherwise have been able to do.”",
  text29: "- Sarah, Co-Founder",
  readMore: "Read More",
  text31:
    "How Outre Clothing Strengthened Their Retail Business Against The Odds Of A Global Pandemic",
  text32:
    "“FundTap has enabled us to grow relatively quickly. If we waited for traditional lending, we would’ve been 6-7 months behind where we are now. It’s relieved a lot of mental stress for me, allowing us to have a safety net to grow our business, gain more customers, and keep on top of our supplier payments.”",
  text33: "- Pranav, Founder",
  text34:
    "How YUM diversified their product range and achieved cost savings with FundTap",
  text35:
    "“We love the convenience and accessibility of FundTap. It’s simple which is really nice and has enabled us to do things we wouldn’t otherwise have been able to do.”",
  text36:
    "YUM are the pioneers of delectable, handmade NZ granola and breakfasts available across the country, to households as well as cafes, hotels and supermarkets.",
  text37:
    "After experiencing high demand and growth, they began observing a pattern in their cashflow and finding themselves in a pinch for a couple of weeks in each month, between receivables and payables, seeking out a solution to help smooth that gap. After speaking to their bank, their bank referred them to; FundTap, a highly regarded local invoice financing service.",
  text38:
    "They were looking for unsecured financing to help with the cyclical pinch they were experiencing. FundTap stood out being a local provider, with a more personal approach to working together, where there was always a person to answer questions and assist.",
  text39:
    "YUM know the growth level they can support with their own capital, and then they choose to work with FundTap when they fluctuate above this. They have been able to launch a new product flavour, No 8 – 100% NZ grown granola. It was a lockdown idea that they were able to push out to the market in 3 months receiving phenomenal sales and growth with support from FundTap.",
  text40:
    "“We are able to achieve scalability more easily with FundTap, making cost savings when ordering larger volumes of ingredients, and having capital available for huge packaging runs with long lead times.”",
  text41:
    "YUM value the speed in which FundTap operate, along with the human beings on the other side of the phone to strategise with and come up with solutions. YUM are looking to switch their packaging to compostable materials involving a large level of capital. They have found that start ups don’t look favourable to a bank on a piece of paper, so considering the progress they have made while using FundTap, they will continue working together to achieve success in this key next step of their growth plan.",
  text42:
    "How Outre Clothing Strengthened Their Retail Business Against The Odds Of A Global Pandemic",
  text43:
    " Outre Clothing, founded by Pranav Maharaj in 2019, was formerly an import and export business allowing New Zealanders competitive access to high end brands such as Tommy Hilfiger. After building up the business in this clear and distinct direction, immense pressure and challenges emerged in early 2020 with the COVID-19 pandemic. The question arose, do we close or can we rethink our business model? With cashflow pressure beginning to build, and observing banks tightening their overdraft and lending options, the idea for Outre Clothing to produce their own line of clothing seemed near impossible, until Pranav reached out to FundTap.",
  text44:
    "The founder of Outre Clothing had weighed up the risk of using their home to release equity, deciding that was too high risk, so he looked to FundTap, a trusted NZ invoice financing business operating since 2010, for a solution that didn’t require his home as collateral.",
  text45:
    "After comparing a handful of invoice financing options, Pranav decided to contact FundTap, due to their reputable brand in NZ, upfront and lower fee structure, and their human assessment of each individual business. He was pleasantly surprised and relieved to discover just how quickly he could receive funds against an invoice, into his business bank account, in time for the regular outgoing business expenses, including wages. With the common challenge in this line of work being a delay in receivables, but requiring payments up front, FundTap were able to solve the timing issue that was causing Pranav sleepless nights.",
  text46:
    "With the Outre Clothing team on board to focus on the domestic market, and with FundTap on board to lend against their invoices within hours, Outre Clothing were able to launch their own line of medical grade masks in August 2020.",
  text47:
    "“FundTap has enabled us to grow relatively quickly. If we waited for traditional lending, we would’ve been 6-7 months behind where we are now. It’s relieved a lot of mental stress for me, allowing us to have a safety net to grow our business, gain more customers, and keep on top of our supplier payments.”",
  text48:
    "Invoice financing allowed Outre Clothing to grow offshore and onshore business, producing much bigger volumes. “With the help of FundTap, we can make larger capital investments. Rather than producing 200 puffer jackets, we can now produce 500 because we have capital funds there to invest, so things move faster, we are our suppliers priority, and we save money by buying higher volumes.”",
  text49:
    " When asked why Pranav specifically chose FundTap as their preferred invoice financer, he explained “FundTap lending is the simplest process I’ve ever had to undertake. Everything is very easy to work through, with a quick turnaround, everything is upfront, and no hidden fees. I never felt like I was talking to a computer, I would phone up and they’d find a customised solution for my business. That human touch is so neccessary and a lot of companies neglect that.”",
  text50: "Enter Your Details",
  text51: "We have sent a One Time Password to your email address now.",
  text52: "Please enter this here:",
  text53: "This Password valid for 5min. Please",
  text54: "Click Here",
  text55: "to resend.",
  text56: "Not sure on something?",
  text57: "Email us at",
  text58: "or call us on:",
  text59: "Please Enter the One Time Password"
};
export const passwordConfirmModal = {
  validationMessage: "Incorrect password",
  validationFailed: "Password validation failed",
  placeholder: "Enter your password",
  passwordRequired: "Password is required"
};

export const responseStatus = {
  success: "success",
  info: "info",
  error: "error",
  errorText: "Something went wrong"
};

export const checklistQuestion = {
  title: "Query for funding",
  subH2:
    "Can you please answer the questions below with supporting files (where applicable).",
  listData: {
    question: "QUESTION: ",
    response: "YOUR RESPONSE:",
    uploadLabel: "UPLOAD FILES (optional):",
    uploadBtn: "Upload",
    submitBtn: "Finish"
  }
};

export const bannerNotiText = {
  mainTitle: "Banner Notification",
  subheading: "Banner Notification Management",
  allUserBtn: "All Banner Notification",
  createUserBtn: "Create Banner Notification",
  table: {
    errMsg: {
      item1: "Error loading sales users:",
      item2: "Delete Banner Notification",
      item3: "Are you sure you want to delete this Banner Notification?",
      item4: "Banner Notification deleted successfully"
    }
  }
};

export const createbannerNoti = {
  subheading: "Create Banner Notification",
  title: "Title",
  message: "Message",
  category: "Category",
  notificationType: "Notification Type",
  link: "Link",
  permissibleAge: "Permissible Age (in days)",
  recurringFire: "Recurring Fire",
  nextFire: "Next Fire (in days)",
  expireAt: "Expire At",
  notificationYear: "Notification year",
  select: "-- Select --",
  notificationMonth: "Notification Month",
  recipientType: "Recipient Type"
};

export const editbannerNotify = {
  errMsg: {
    item1: "Error fetching banner Notification:",
    item2: "Value cannot be greater than 60.",
    item3: "Value cannot be greater than 3."
  }
};

export const fundedAmmount = {
  errMsg: {
    item1: "Only 'FT' is allowed to search Invoice No",
    item2:
      "You are INCREASING the funded amount. Please confirm if you want to do this.",
    item3: "Valid Invoice No.",
    item4: "Invalid Invoice No.",
    item5:
      "This invoice is already {{status}}. Changing the funded amount re-calculates its fee and total and writes the change back to the accounting software."
  },
  mainTitle: "Update Funded Amount",
  invNo: "Invoice No.",
  currentFundedAmount: "Current Funded Amount",
  newFundedAmount: "New Funded Amount",
  fundedAmount: "Funded Amount",
  invoiceStatus: "Invoice Status",
  guardedStatusTitle: "Invoice already funded",
  guardedStatusFallback: "funded or completed"
};

export const manualPaymentSync = {
  mainTitle: "Payment Updates",
  subheading: "Manual Payment Synchronization",
  syncNow: "Sync Now",
  lastSync: "Last Sync",
  resultOfLastSync: "Result of last sync on",
  at: "at",
  noSyncInProgress: "No sync in progress",
  sync: "Sync",
  note: "Note that it will call xero api for multiple organizations",
  noData: "No data available",

  option: {
    due: "All Due Invoices",
    overdue: "All Overdue Invoices",
    particular: "A Particular Invoices",
    funded: "All Funded Invoices"
  },
  value: {
    due: "due",
    overdue: "overdue",
    funded: "funded",
    particular: "particular"
  },
  quoteId: "Quote ID",
  enterQuoteId: "Enter Quote ID",
  syncInProgress: "Sync is in progress",
  syncProgressNote:
    "This page will show you result automatically after the sync completes",
  syncCompleted: "Sync Completed",
  syncFailed: "Sync Failed",

  table: {
    logId: "Log ID",
    quoteId: "FT No.",
    status: "Update Found",
    message: "Message",
    startTime: "Start Time",
    endTime: "End Time",
    action: "Action"
  },
  lastSyncInfo: {
    syncedAt: "Synced At",
    status: "Status",
    recordsProcessed: "Records Processed",
    successCount: "Success Count",
    failureCount: "Failure Count",
    triggeredBy: "Triggered By",
    syncType: "Sync Type"
  },
  timeAgo: {
    justNow: "Just now",
    minutesAgo: "{count} minutes ago",
    hoursAgo: "{count} hours ago",
    daysAgo: "{count} days ago"
  },
  errors: {
    fetchStatusFailed: "Failed to fetch payment data",
    startSyncFailed: "Failed to start sync",
    fetchLogsFailed: "Failed to fetch sync logs",
    fetchLastSyncFailed: "Failed to fetch last sync info"
  }
};

export const jobQueueHealth = {
  mainTitle: "Job Queue Health",
  subheading:
    "Invoice-sync queue depth, worker utilisation, and in-flight jobs",
  queueDepth: "Queue Depth",
  activeWorkers: "Active Workers",
  poolSize: "Pool Size",
  maxPoolSize: "Max Pool Size",
  oldestInFlightJob: "Oldest In-Flight Job",
  none: "None",
  byStatus: "In-Flight Jobs by Status",
  byCustomer: "In-Flight Jobs by Customer",
  noJobsInFlight: "No jobs currently in flight",
  customerColumn: "Customer",
  countColumn: "Count",
  statusColumn: "Status",
  refreshing: "Refreshing...",
  errors: {
    fetchFailed: "Failed to fetch job queue health"
  }
};

export const timeDaySubmitted = {
  mainTitle: "Report About Invoices Submitted Time",
  subTitle: "Customers list whose are submitted the invoices in between",
  filter: {
    customerFilter: "Customer Filter :"
  },
  reportModal: {
    errMsg: {
      item1: "File downloaded successfully",
      item2: "Month",
      item3: "Failed to download report",
      item4: "Payment Created successfully"
    },
    title: "Download Filter"
  }
};

export const allInvData = {
  errMsg: {
    item1: "Successfully downloaded",
    item2: "Failed to download invoice"
  }
};

export const userManage = {
  mainTitle: "Access Management",
  content: "User Management",
  activeUser: "Active Users",
  creteUser: "Create User",
  deactiveUserBtn: "Deactivated Users",
  deleteUser: "Deleted Users",
  errMsg: {
    item1: "Delete User",
    item2: "Are you sure you want to delete this User?",
    item3: "User account deleted successfully",
    item4: "Are you sure you want to delete this Users?",
    item5: "Selected users deleted successfully",
    item6: "Failed to retrieve valid tokens. Please try again.",
    item7: "Failed to login as the selected user. Please try again.",
    item8: "An error occurred while attempting to login.",
    item9: "Login as user successfully"
  },
  batchDelete: "Batch Delete",
  permanetDelete: "Parmanent Delete",
  unassigned: "Unassigned",
  goToRole: "Go to role"
};

export const changeUserPass = {
  errmsg: {
    item1: "Password should be at least 8 characters.",
    item2: "Password should contain at least one digit.",
    item3: "Password should contain at least one capital letter.",
    item4: "Password should contain at least one special character.",
    item5: "Passwords do not match.",
    item6: "Passwords match",
    item7: "Error fetching username:"
  },
  subH2: "Change Password for",
  password: "Password",
  passowrdConfirm: "Password Confirmation"
};

export const createUser = {
  errMsg: {
    item1: "The Email format is invalid.",
    item2: "First Name field is required",
    item3: "Last Name field is required",
    item4: "Confirm Password do not match.",
    item5: "Please select at least one role."
  },
  mailAdress: "E-mail Address",
  activeDeactive: "Activate / Deactivate User",
  confirmed: "Confirmed",
  sendConfirmEmail: "Send Confirmation E-mail",
  sendEmailText: "(If 'Confirmed' is unchecked)",
  associatedRoles: "Associated Roles"
};

export const editUser = {
  unlockUser: "Unlock User",
  lockUser: "Lock User",
  errmsg: {
    item1: "Are you want to unlock the 30 min lockout?",
    item2: "Are you sure you want to lock this user?",
    item3: "User has been unlocked.",
    item4: "User has been locked for 30 minutes.",
    actionCancel: "Action cancelled.",
    item5: "Error updating lock status:",
    item6: "The Last Name field is required.",
    item7: "Middle Name must contain only alphabetic characters and spaces.",
    item8: "The Email field is required."
  },
  editUserBtn: "Edit Users",
  lockUnlock: "Lock / Unlock Profile"
};

export const viewUser = {
  subH2: "View User",
  overview: "Overview",
  userOveriew: {
    secondAgo: "seconds ago",
    minutesAgo: "minutes ago",
    hoursAgo: "hours ago",
    daysAgo: "days ago"
  },
  profilePic: "Profile Picture",
  emailConfirmed: "Email Confirmed",
  accountStatus: "Account Status",
  createdAt: "Created At",
  lastUpdatedAt: "Last Updated At"
};

export const userHistory = {
  text: "There is no history for this User."
};

export const deActiveUser = {
  batchDelete: "Batch Delete"
};

export const deletedUser = {
  errMsg: {
    item1: "Restore user",
    item2: "Are you sure you want to restore this user?"
  }
};

export const roleMange = {
  label1: "Role Name",
  label2: "2FA Status",
  label3: "Display Order",
  label4: "Status",
  label5: "Assigned Permissions",
  label6: "Assigned Nav Items",
  content: "Role Management",
  editRole: "Edit Role",
  subheading: "All Roles",
  placeholder1: "Role Name",
  createRole: "Create Role",
  table: {
    fullAccess: "Full Access",
    limitedAccess: "Limited Access"
  },
  userListModal: {
    title: "User List"
  },
  limitedAccModal: {
    title1: "Role #",
    title2: "Permissions"
  },
  errorMsg: {
    roleNameError: "The role name field is required.",
    rolenameErrorSet: "Role name can only contain letters.",
    errorOrderMsg: "The order number field is required.",
    permissionTypeError:
      "You must select at least one permission for this role."
  }
};
export const permissionManagement = {
  content: "Permission Management",
  subheading: "All Permissions",
  createPermission: "Create Permission",
  label1: "Permission Name",
  label2: "Status",
  label3: "End Point",
  label4: "Description",
  label5: "Method",
  downloadError: "Error downloading file",
  uploadError: "Error uploading file",
  uploadSuccess: "File uploaded successfully"
};

export const allLogs = {
  mainTitle: "Activity Logs",
  content: "All Logs",
  table: {
    name: "Name:",
    email: "Email:",
    pofessionalTrustee: "Professional Trustee:",
    invalidData: "Invalid trustee data format",
    noAdditionalData: "No additional information available."
  },
  logsModal: {
    formText: '"From date" can not be gretter than "to date"',
    noRecordErr: "No record found for the given date range.",
    exportTitle: "Export Activity Logs",
    fromDate: "From Date",
    toDate: "To Date",
    validationMsg: "Duration between dates should be less than 3 months."
  }
};

export const reyPaymentLogs = {
  mainTitle: "FundTap",
  content: "Administrative Dashboard",
  subheading: "Repayment Logs",
  errMsg: {
    item1: "An Accuard error",
    item2: "vvvvv",
    item3: "vvvvv",
    item4: "vvvvv",
    item5: "vvvvv"
  }
};

export const emailTemplate = {
  mainTitle: "Email Template Management",
  emailType: "Email Type",
  emailOptions1: "All",
  emailOptions2: "Customer Email",
  emailOptions3: "Referral Email",
  emailOptions4: "Admin Email",
  mailTo: "Mail To:",
  modalTitle: "Enter an email address",
  emailRequired: "Enter an email address",
  invalidEmail: "Enter a valid email address"
};

export const editEmailTemp = {
  content: "Edit Email Template",
  dymicContent: "Dynamic contents",
  templateName: "Template Name",
  subject: "Subject",
  triggerDescription: "Trigger Description",
  fromEmail: "From Email",
  fromName: "From Name",
  cc: "CC",
  to: " To",
  addElement: "Add a new Element",
  selectElement: "--Select An Element--",
  selectElementLi: {
    item1: "Add new Paragraph",
    item2: "Add new Button",
    item3: "Add new Link",
    item4: "Horizontal line"
  },
  contentText: "content",
  textAlignment: "Text Alignment",
  textAlignmentLi: {
    item1: "Left",
    item2: "Center",
    item3: "Right"
  },
  fontWeight: "Font Weight",
  fontSize: "Font Size",
  updateParagraph: "Update Paragraph",
  addParagraph: "Add Paragraph",
  deleteParagraph: "Delete Paragraph",
  buttonLink: "Button link (url with http://)",
  buttonText: "Button Text",
  fullWidthButton: "Full Width Button",
  deleteButton: "Delete Button",
  updateButton: "Update Button",
  addButton: "Add Button",
  linkURL: "Link URL",
  linkText: "Link Text",
  updateLink: "Update Link",
  addLink: "Add Link",
  deleteLink: "Delete Link",
  updateLine: "Update Line",
  addLine: "Add Line",
  deleteLine: "Delete Line",
  templatePreview: "Template Preview",
  fundTap: "FundTap.",
  allRightsReserved: "All rights reserved."
};

export const smsTemplate = {
  mainTitle: "SMS Template Management",
  userTriggered: "User Triggered",
  errmsg: {
    item1: "Error fetching template:",
    item2: "Failed to load template",
    item3: "Delete SMS Template",
    item4: "Are you sure you want to delete this SMS Template?"
  },
  smsAll: "SMS - All",
  autoTiming: "SMS - Auto Timing",
  fundTapTriggered: "SMS - FundTap User Triggered",
  createBtn: "Create SMS Template",
  smsType: "SMS Type",
  smsTypeLi: [
    {
      name: "All",
      value: ""
    },
    {
      name: "SMS - Auto Timing",
      value: "Auto Timed"
    },
    {
      name: "SMS - FundTap User Triggered",
      value: "User Triggered"
    }
  ],
  sendModal: {
    errmsg: {
      item1: "Message sent successfully!"
    },
    enterSmsAddress: "Enter an SMS address",
    to: "To:",
    form: "From:",
    fundtap: "FundTap (AU)",
    number: "6421804033 (NZ)"
  }
};

export const createSmstemp = {
  errMsg: {
    item1: "SMS template already exists."
  },
  mainTitle: "SMS Template Management",
  content: "Create SMS Template",
  creteTemp: "Create Template",
  triggerPlaceholder: "Please enter trigger description",
  smsContent: "Your preview will appear here...",
  templatePlaceholder: "Please enter SMS template name",
  templatePreview: "Write Here"
};

export const editSmsTemp = {
  content: "Edit SMS Template",
  subh2: "Edit Template -"
};

export const customers = {
  mainTitle: "CUSTOMERS LIST",
  userType: "User Type :",
  statusFilter: "Status Filter :",
  goTouser: "Go to user",
  regular: "REGULAR",
  customer: "Customer",
  topAction: {
    errMsg: {
      item1: "You must select one customer for this action.",
      item2: "Users account deleted successfully"
    },
    eidtUser: "Edit User",
    deactiveUser: "Deactivate User",
    changeUserPass: "Change User Password",
    resendMail: "Resend Mail"
  }
};

export const customersDtls = {
  tabs: {
    title1: "Customer",
    title3: "Financials",
    title4: "Owner",
    title5: "Trust & Corporates",
    title6: "Checklist",
    title7: "Step 5: Other Owners?",
    title8: "Trust_Corporate_Summary_Comment"
  },
  customerCmntModal: {
    title: "Comments",
    notRegistered: "NOT REGISTERED",
    commentsHere: "Comments here",
    followingUser1:
      "The following User and Owner do not have updated/verified Agreements (version greater than 6):",
    user: "(User)",
    owner: "owner 1 (Owner)",
    followingUser2:
      "The following User, Owner, Trust and Corporate do not have updated/verified Guarantees",
    version: "(version greater than 7):",
    hellowTrust: "Hello trust (Trust)",
    corporate: "(Corporate)",
    propertyRep:
      "Property report is more than 12 months old. Get a new property report and review",
    comment: "Comment:",
    propertyText:
      "Property report is more than 12 months old. Get a new property report and review",
    validate: "Validate Phone Numbers",
    thePrimary: "The primary number",
    andSecondary: "and the secondary number",
    haveNot: "have not been validated yet!",
    hasNot: "has not been validated yet!",
    theSecondary: "The secondary number",
    hasNot2: "has not been validated yet!",
    forceBtn: "Force Validate",
    text1: "Fields requierd to pass customer"
  },
  errMsg: {
    item1: "not connected",
    item2: "Select a accounting software",
    item3: "Please enter the question"
  },
  disconnected: "Disconnected",
  at: "at",
  notFound: {
    item1: "4",
    item2: "0",
    item3: "4",
    item4: "3",
    oops: "Oops... Looks like the page is not there!",
    forbidden: "Oops... You do not have permission to access this resource!",
    goToHomeBtn: "GO TO HOME",
    goToDashboardBtn: "GO TO HOME"
  },
  customerHead: {
    errMsg: {
      item1: "Fields required to pass customer",
      item2: "Referral partner updated successfully"
    },
    pipedrive: "Pipedrive",
    hubspot: "Hubspot",
    tolltip1: "No Organization URL found",
    tolltipHubspot: "No Hubspot Company URL found",
    userName: "User name",
    reffPartner: "Referral Partner",
    salesLead: "Sales Lead",
    salesEditModal: {
      title: "Customer Sales lead Edit",
      updateBtn: "Update Sales lead"
    },
    statusUpdate: {
      title: "Enter Status details",
      statusDetails: "Status Details:",
      otherStatusDtls: "Other Status Details:"
    }
  },
  noteCmmnt: {
    first: {
      titleText: "POP-UP COMMENT",
      addText: "Pop-up",
      placeholder: "Put a Pop-up Here",
      addBtnText: "ADD A NEW COMMENT",
      responseMsg: "Comment"
    },
    second: {
      titleText: "GENERAL NOTES",
      sureDeleteMsg: "Are you sure to remove this General Note?",
      addText: "Pop-up",
      placeholder: "Put a Pop-up Here",
      addBtnText: "Note",
      addNewNoteBtnText: "ADD A NEW NOTE",
      responseMsg: "Note"
    },
    CloseBtn: "Close this Panel",
    add: "Add",
    addedBy: "Added By",
    on: "on",
    form: "from",
    remove: "remove"
  }
};

export const agreementMailPages = {
  addOwners: {
    title: "Other Owners",
    addBtn: "Add Owner",
    finalText: `Once you have added all owners, please click "Submit" below:`,
    successText: `Thanks! You're all set. You can close this browser window now. If you have any questions, don't hesitate to get in contact with Fundtap at`
  },
  guaranteeNoID: {
    title: "FundTap Guarantee",
    unsupportedFile: "Unsupported file extension"
  },
  biometricIDverification: {
    title: "Verify Your Identity",
    submitbtn: "Send Link to my Phone",
    lastText:
      "Once you have fully completed your ID check, this page will update - it may take 30 seconds so please don’t navigate away."
  },
  idOnly: {
    completed: "You have already completed the verification process."
  }
};

export const customerTab = {
  details: {
    errMsg: {
      item1: "successfully connected",
      item2: "Error fetching NZBN data",
      item3: "Customer information updated successfully."
    },
    mainTitle: "CUSTOMER DETAILS",
    accSoftware: "ACC. SOFTWARE",
    liabilityAccount: "Liability Account:",
    expenseAccount: "Expense Account:",
    bankAccount: "Bank Account:",
    lessDetails: "Less details",
    moreDetails: "More details",
    country: "COUNTRY",
    abn: "ABN",
    nzbn: "NZBN",
    selectNzbn: "Select NZBN",
    orgType: "ORG TYPE",
    accType: "ACCOUNT TYPE",
    acn: "ACN",
    companyNo: "Company No.",
    legalName: "LEGAL NAME",
    companyStatus: "COMPANY STATUS",
    tradingName: "TRADING NAME",
    taxNumber: "TAX NUMBER",
    industry: "INDUSTRY",
    infoFound: "No info found.",
    noIndustry: "No industry types available",
    industryDetails: "INDUSTRY DETAILS",
    age: "AGE",
    industryClassfication: "INDUSTRY CLASSIFICATION",
    unbleToFetch: "Unable to fetch industry classification types.",
    m10Acc: "M10 CCB Account",
    m10Local: "M10 Local Account",
    countryInfo: {
      title: "Country Information",
      accCountry: "Account Country:",
      websiteEntry: "Website Entry:"
    }
  },
  systemControl: {
    errMsg: {
      item1: "You are going to",
      item2:
        "the Cash-Flow Buddy menu for this customer. Are you sure you want to proceed?",
      item3: "You are",
      item4:
        "permission to update the old invoice amount while syncing. Are you sure you want to proceed?"
    },
    enable: "enable",
    enabling: "enabling",
    disable: "disable",
    disabling: "disabling",
    title: "CONTROLS",
    skipAppProcss: "Skip Application Process",
    forceAppProcss: "Force Application Process",
    enableCfb: "Enable CFB Menu",
    invcsUpload: "Invoice Upload",
    pastInvcDate: "Past Invoice Due Date",
    pastInvcAmmnt: "Past Invoice Amount",
    rebootIncsSync: "Reboot Invoice Sync",
    accWriteBack: "Acc. Write-back",
    proofOfPayment: "Proof of payment required?"
  },
  directDebit: {
    errMsg: {
      item1: "Remove Mandate ID?",
      item2: "You are removing mandate ID. Are you sure you want to proceed?",
      item3: "Change Mandate ID?",
      item4: "You are changing mandate ID. Are you sure you want to proceed?",
      item5: "Change Account Number?",
      item6:
        "You are changing bank account number. Are you sure you want to proceed?",
      item7: "Relink Bank Account?",
      item8:
        "You are attempting to update the bank account number. Are you sure you want to proceed?",
      emptyMandateId: "Mandate ID cannot be empty.",
      mandateIdRequired: "Mandate ID is required to update GoCardless status.",
      noMandateIdToRemove: "No mandate ID available to remove."
    },
    title: "DIRECT DEBIT",
    directDebit: "Direct Debit",
    mandateId: "Mandate Id",
    mandateStatus: "Mandate Status",
    links: "Links",
    mandate: "Mandate",
    checkStatus: "Current Status",
    unlinked: "Unlinked",
    linked: "Linked",
    relinkAcc: "Relink Account",
    selectBankAcc: "Select bank account",
    bankPlaceholder: "Enter bank account",
    manuallyAddAcc: "Manually add bank account",
    externalBnkAcc: "External Bank Accounts",
    unabletoRefresh1:
      "Unable to refresh bank accounts as the direct debit mandate process has not completed.",
    unabletoRefresh2:
      "Unable to refresh bank accounts due to a lack of connection with the accounting software.",
    unavalbleModal: {
      title: "Unavailable",
      weAre:
        "We are unable to locate the status of the GoCardless mandate. This is due to the absence of a corresponding mandate ID in our database."
    },
    auBankError: "Bank account must be between 7 to 15 digits for AU",
    nzBankError: "Bank account must be between 14 to 16 digits for NZ",
    refreshAlert:
      "Are you sure you want to retrieve the bank account data? Please be aware that this action will initiate calls to both the Accounting Software and the GoCardless API."
  },
  userContactDtls: {
    errMsg: {
      item1: "Phone number must contain only numeric characters."
    },
    title: "USER CONTACT DETAILS",
    businessEmail: "BUSINESS Emails",
    businessPhone: "BUSINESS PHONE",
    registerdAdress: "REGISTERED ADDRESS",
    addressForService: "ADDRESS FOR SERVICE",
    website: "WEBSITE",
    noWebsite: "No Website URL Provided"
  },
  marketing: {
    errMsg: {
      item1:
        "You are changing the contact no. Are you sure you want to proceed?",
      item2: "Accountant contact number permission updated successfully"
    },
    title: "MARKETING AND ACCOUNTANTS DETAILS",
    accName: "Accountant Name",
    firm: "Firm",
    contactNo: "Contact No.",
    heardFrom: "Heard from",
    GCLID: "GCLID"
  },
  customerLog: {
    title: "CUSTOMER LOG",
    evenTextt: "Event"
  }
};

export const invoiceTab = {
  submittedInv: "Submitted Invoices",
  allInv: " All Invoices",
  totalsByState: "Totals by state",
  customerInvTable: {
    errMsg: {
      item1: "Upload failed",
      item2: "Quote downloaded successfully",
      item3: "Status Change",
      item4: "Are you sure you want to change the status?",
      item5: "Updated successfully!",
      item6: "Upload",
      item7: "Change Repay Date"
    },
    quoteDetailsTexxt:
      "The repayment date is delayed by more than 30 days from the due date.",
    invcsArenotEligible: "Invoices are not eligible to change repay date",
    invcsFilter: {},
    autoUpload: "AUTHORISED",
    manualUpload: "User Entered"
  },
  allinvoiceTable: {
    errMsg: {
      item1: "Quote not found for ID:"
    },
    promoCode: {
      proomoholder: "Valid Promo Code",
      promoApply: "Promo code applied",
      notValidPromo: "Not a valid promo code."
    }
  }
};

export const financeTab = {
  creditScore: {
    modalText: "Successfully deleted credit report.",
    uploadCreditModal: {
      title: "UPLOAD CREDIT REPORT",
      creditScoreTitle: "CREDIT SCORE:",
      adverse: "ADVERSE:",
      activity: "ACTIVITY:",
      creditReport: "CREDIT REPORT:",
      creditRisk: "CREDIT RISK:"
    },
    creditReportModal: {
      title: "Credit Report",
      selectOrg: "Select Organisation",
      generateBtn: "Generate Company enquiry",
      text1: "Only if the entity does not have an ACN, click",
      text2: "here",
      text3: "to search for a Business Enquiry"
    },
    finacialComment: {
      errMsg: {
        item1: "deleted successfully",
        item2: "added successfully"
      }
    },
    pricingPlanModal: {
      title: "Pricing Plan History"
    }
  },
  funding: {
    errMsg: {
      item1: "Credit Limit cannot be blank."
    },
    title: "FUNDING",
    creditLimit: "CREDIT LIMIT",
    totalCompleted: "TOTAL COMPLETED",
    totalFees: "TOTAL FEES",
    fundInvs: "FUNDED INVS.",
    fundedDue: "FUNDED DUE",
    arCurrent: "AR CURRENT",
    availableCredit: "AVAILABLE CREDIT",
    creditLimitHistModal: {
      title: "Credit Limit History",
      tableTitle1: "Credit Limit",
      tableTitle2: "Updated by",
      tableTitle3: "Updated Date",
      noRecordFound: "No record of credit limit history found.",
      from: "From",
      to: "to"
    }
  },
  ppsr: {
    errMsg: {
      item1:
        "Please provide debtor organisation name or incorporation number or NZBN",
      item2: "NZBN number must be provided"
    },
    title: "PPSR",
    gsaRank: "GSA RANK",
    notRequired: "NOT REQUIRED",
    reasonForNoPpsr: "REASON FOR NO PPSR",
    reasonForNoPpsrSmall: "Reason for No PPSR:",
    comment: "COMMENT",
    financingStatement: "FINANCING STATEMENT"
  },
  financialRegister: {
    errMsg: {
      item1: "Discharge PPSR",
      item2: "Are you sure you want to Discharge this PPSR?"
    },
    registerPpsr: "REGISTER PPSR",
    uploadPpsr: "Upload PPSR",
    editDetails: "Edit Details",
    discharge: "DISCHARGE",
    noPpsrRecord: "No PPSR Registration record.",
    registerFinance: "REGISTER FINANCING STATEMENT",
    ppsrRegisterModal: {
      errMsg: {
        item1: "Only numbers and commas are allowed.",
        item2: "Only letters, numbers and commas are allowed."
      },
      editPpsr: "Edit PPSR Manually",
      uploadPpsr: "Upload PPSR Manually",
      registrationId:
        "Registration ID (Use comma to separate multiple registration IDs):",
      pinChange:
        "PIN/CHANGE No (Use comma to separate multiple change numbers):",
      expiryDate: "EXPAIRY DATE",
      updatePpsrBtn: "UPDATE PPSR",
      uploadPpsrBtn: "UPLOAD PPSR"
    },
    ppsrDetailsModal: {
      title: "PPSR Details",
      errorTitle: "PPSR Validation",
      errorMessage:
        "Please make sure all required fields are completed before registering.",
      allPapNoExcept: "COLLATERAL TYPE: AllPapNoExcept",
      description1:
        "Description: All Present and After-Acquired Property - No Exceptions",
      generalIntangible: "COLLATERAL TYPE: GeneralIntangible",
      description2:
        " Description: All present and after acquired accounts receivable purchased from the debtor from time to time by, or from, the secured party and proceeds; all the debtors other present and after acquired accounts receivable from time to time and proceeds; all the debtors other present and after acquired personal property.",
      orgName: "Organisation Name",
      aapp: "COLLATERAL TYPE: AAPP",
      int: "COLLATERAL TYPE: INT",
      intDescription:
        "Description: All present and after acquired accounts receivable purchased from the debtor from time to time by the secured party and proceeds; all present and after acquired accounts receivable purchased by the debtor from time to time from the secured party and proceeds; all the debtors other present and after acquired accounts receivable from time to time and proceeds; any other present and after acquired personal property agreed to by the debtor from time to time and proceeds; all the debtors other present and after acquired personal property."
    },
    ppsrAbnModal: {
      pleaseEnter1:
        "Please enter The ACN and ABN for this client first before registering a Financing Statement.",
      closeandEnter1: "Close and enter ACN & ABN",
      onlyIf1:
        " Only if neither the ACN or ABN is available for this customer, then click below to register a financing statement using the legal name of the ntity.",
      registerUsing: "Register using Legal Name",
      pleaseEnter2:
        "Please enter The ACN for this client first before registering a Financing Statement.",
      closeandEnter2: "Close and enter ACN",
      onlyIf2:
        "Only if the ACN is not available for this customer i.e. sole trader etc, then click below to register a financing statement using the ABN of the entity.",
      auSole:
        "AU Sole Traders and Partnerships should have an ABN and we must register against this.",
      registerAbn: "Register using ABN"
    }
  }
};

export const ownerTab = {
  addOwner: "Add Owner",
  deleteOwner: "Delete Owner",
  archiveOwner: "Archive Owner",
  reactivateOwner: "Active Owner",
  inactiveLabel: "inactive",
  stepContent: {
    idRequirement:
      "If you have other Directors, or business partners who have a 25% share, or greater, we will need to ID them to provide Funding.",
    addOwnerInstructions:
      'Please click "Add Owner" and enter their name and email. We will email to get their ID details (it\'s the same ID process as you have just done here)'
  },
  errMsg: {
    item1: "Delete Owner",
    item2: "Are you sure you want to delete this owner?",
    item3: "Owner deleted successfully",
    item4: "Failed to delete owner",
    item5: "Error deleting owner",
    item6: "Successfully updated.",
    item7: "Failed to Update",
    item8: "Error updating data:"
  },
  statusModal: {
    archiveTitle: "Archive Owner",
    reactivateTitle: "Reactivate Owner",
    archiveLabel: "Reason for marking this owner as inactive",
    reactivateLabel: "Reason for reactivating this owner",
    placeholder: "Please enter a reason",
    reasonRequired: "A reason is required",
    archiveSuccess: "Owner marked as inactive successfully",
    reactivateSuccess: "Owner reactivated successfully",
    archiveError: "Failed to mark owner as inactive",
    reactivateError: "Failed to reactivate owner"
  },
  directorsOwner: {
    errMsg: {
      item1: "Comment updated successfully"
    },
    title: "DIRECTORS AND OWNERS",
    th1: "OWNERS",
    th2: "DIRECTOR",
    th3: "SHAREHOLDING",
    ownerShipCommnt: "Ownership Comment",
    ownerHistoryModal: {
      title: "Director/Shareholder History",
      date: "Date:"
    }
  },
  ownerInfo: {
    errMsg: {
      item1: "All supporting documents have been deleted.",
      item2: "Please select supporting documents.",
      item3: "Delete document",
      item4: "Are you sure you want to delete this file?",
      item5: "Supporting document deleted successfully",
      item6: "Delete File",
      item7: "Are you sure you want to delete this File?",
      item8: "File deleted successfully",
      item9: "Please select an Agreement",
      item10: "Please select a file.",
      ftAgreementDateError: "Failed to update the FT agreement completed date.",
      ftPpsrFetchError: "Failed to load the FT agreement and PPSR status."
    },
    swalItems: {
      item1: "Agreement type",
      item2: "Please select Agreement type.",
      item3: "First Name",
      item4: "Please input first name.",
      item5: "Last Name",
      item6: "Please input last name.",
      item7: "Personal Address",
      item8: "Please input personal address."
    },
    pipedrive: "Pipedrive:",
    tooltipContent: "No Person URL found",
    roles: "Roles:",
    shareholder: "Shareholder",
    manager: "Manager",
    propertOwner: "Property Owner",
    password: "Password:",
    resetPass: "RESET PASSWORD",
    agreement: "AGREEMENT",
    forceNz: "FORCE NZ DOCUMENT",
    forceAu: "FORCE AU DOCUMENT",
    th1: "FILENAME",
    th2: "DATE",
    supportingDocs: "SUPPORTING DOCS",
    ftAgreementCompletedDate: "DATE FT AGREEMENT SIGNED",
    selectFtAgreementDate: "Select date signed",
    selectSupportingDocs: "Select Supporting Document",
    multiselect: {
      key1: "Invoices",
      key2: "ID - Licence or Passport",
      key3: "ID - Photo",
      key4: "Tax",
      key5: "Accounts - Account Payable",
      key6: "Accounts - Accounts Receivable",
      key7: "Accounts - Balance Sheet",
      key8: "Accounts -  Profit and Loss",
      key9: "Accounts - General",
      key10: "Bank Statements",
      key11: "Trust Deed",
      key12: "Others"
    },
    directorsResolutionModal: {
      title: "FT Directors Resolution Information",
      director: "DIRECTOR",
      name: "NAME",
      email: "EMAIL",
      chairman: "IS CHAIRMAN",
      excludeEmail: "EXCLUDE EMAIL",
      errMsg: {
        atLeastOneDirector: "Please add at least one director.",
        oneChairmanRequired: "Please select exactly one chairman.",
        nameAndEmailRequired:
          "Please add director name and email for all directors.",
        invalidEmail: "Please enter a valid email address."
      },
      successMsg: "Directors resolution email sent successfully"
    },
    demandLetterModal: {
      title: "Generate Demand Letters",
      daysLabel: "Days until Demand Payment Due:",
      description:
        "A letter is produced for the organisation and for every personal, trust and corporate guarantee on file. Letters are saved as Word documents under Agreements — nothing is sent.",
      warningsTitle: "Complete these before sending:",
      filedTitle: "Letters filed under Agreements:",
      errMsg: {
        daysRequired: "Please enter the days until demand payment is due.",
        daysRange: "Days until demand payment due must be between 1 and 365."
      },
      successMsg: "Demand letters generated successfully"
    }
  },
  ownerDetails: {
    errMsg: {
      item1:
        "Name should only contain letters, spaces, hyphens and apostrophes",
      item2: "Please input a valid mobile number",
      item3: "Primary and secondary number should not be same!",
      item4: "Invalid phone number!",
      item5:
        "Phone number must start with +64 (New Zealand) or +61 (Australia).",
      item6: "Are you sure to you want to change the email?"
    },
    title: "OWNER DETAILS",
    preferedName: "PREFERRED NAME",
    gender: "GENDER",
    choose: "Choose",
    male: "Male",
    female: "Female",
    phone1: "PHONE 1",
    accUserName: "Account Username",
    phone2: "PHONE 2",
    sendSmsModal: {
      title: "Send SMS",
      selectTemplate: "Select Template:",
      selectSmsTemplate: "Select SMS Template",
      sendFtUser: "Send from FT User:",
      selectFtUser: "Select FT User",
      smsContent: "SMS Content:",
      characterCount: "Character count:",
      templateOne: "Temp One - For New",
      reckon123: "Reckon 123",
      FundtapAdmin: "Fundtap Admin"
    }
  },
  identification: {
    errMsg: {
      item1:
        "Middle Name should only contain letters, spaces, hyphens and apostrophes",
      item2:
        "First Name should only contain letters, spaces, hyphens and apostrophes",
      item3:
        "Last Name should only contain letters, spaces, hyphens and apostrophes",
      item4: "Error updating apply mandatory"
    },
    manualUploadTable: {
      errMsg: {
        item1: "Document delete successfully",
        item2: "An error occurred during the file upload. Please try again.",
        item3: "Identification documents updated successfully",
        item4:
          "An error occurred while updating the document. Please try again.",
        item5: "Please select an ID type.",
        item6: "Passport number is required.",
        item7: "Expiry date is required.",
        item8: "Please enter the license number.",
        item9: "State is required.",
        item10: "Card number is required.",
        item11: "Other number is required.",
        item12: "Version is required.",
        item13: "Please upload a file."
      },
      editIdentiBtn: "Edit Identification",
      addIdentiBtn: "Add new identification",
      idType: "ID TYPE:",
      passport: "Passport",
      drivingLicense: "Driving License",
      number: "NUMBER",
      expiryDate: "EXPIRY DATE:",
      uploadFile: "UPLOAD FILE:",
      licenseNumber: "LICENCE NUMBER:",
      state: "STATE:",
      selectState: "Select State",
      selectStateLi: {
        li1: "ACT",
        li2: "NSW",
        li3: "NT",
        li4: "QLD",
        li5: "SA",
        li6: "TAS",
        li7: "VIC",
        li8: "WA"
      },
      cardNumber: "CARD NUMBER:",
      version: "VERSION:"
    },
    addressModal: {
      title: "Change personal address",
      streetAddress: "Personal street address:",
      city: "City:",
      postCode: "Post Code:"
    }
  },
  directorShip: {
    title: "Directorships",
    directorCommnt: "Directorship Comment",
    updateSuccess: "Update successfully",
    errMsg: {
      item1: "Failed to delete row"
    },
    searchDirector: {
      directors: "Directors",
      shareholders: "Shareholders",
      companyList: "Company List",
      selectCompany: "Select Company"
    }
  },
  creditScore: {
    title: "CREDIT SCORE",
    noteComment: {
      titleText: "COM. CREDIT COMMENT",
      creditComments: "CREDIT COMMENTS"
    }
  },
  proprtyDetails: {
    title: "Property",
    popertyOwnership: "Property Ownership",
    propertyEquity: "PROPERTY EQUITY",
    propertyOwnedAddrs: "Property Owned Address",
    onhouseLink: "onthehouse.com.au",
    propertyGuruLink: "propertyguru.corelogic.co.nz",
    noteComment: {
      titleText: "PROPERTY COMMENTS",
      sureDeleteMsg:
        "Are you sure you want to remove this comment permanently?",
      addBtnText: "UPDATE COMMENT"
    },
    table: {
      errMsg: {
        item1: "Property deleted successfully"
      }
    },
    uploadModal: {
      addProperty: "Add Property",
      copyProperty: "Copy Property"
    },
    addModal: {
      file: "File",
      errMsg: {
        item1: "exceeds the 5MB limit.",
        item2: "is not an allowed type (JPEG, PNG, GIF, PDF).",
        item3: "This property RV field is required",
        item4: "This mortgage field is required",
        item5: "This field is required"
      },
      propertyAdd: "Property Add",
      address: "Address:",
      selectAddrss: "Select Address",
      manualAddrss: "Manual Address",
      owner: "Owner",
      trustOrCorporate: "Trust or Corporate:",
      trust: "Trust",
      corporate: "Corporate",
      propertyRv: "Property RV:",
      mortgage: "Mortgage:",
      equity: "Equity:",
      directorProperty: "Director Property Report"
    },
    editModal: {
      propertyEdit: "Property Edit"
    },
    reportModal: {
      errMsg: {
        item1:
          "Only following states are allowed: NSW, QLD, WA, SA, NT, ACT, TAS and VIC",
        item2: "Street Number is required",
        item3: "Street Name is required",
        item4: "Suburb is required"
      },
      title: "Property Report",
      searchBy: "Search by:",
      ownerName: "Owner Name",
      propertyAddrss: "Property address",
      streetNumber: "Street Number:",
      streetName: "Street Name:",
      streetType: "Street Type:",
      suburb: "Suburb:"
    },
    copyModal: {
      title: "Property Copy",
      selectOwner: "Select Owner:",
      selectProperty: "Select Prperty :",
      notSelect: "Please select a property to copy"
    }
  },
  registerPPSR: {
    errMsg: {
      item1: "Discharge PPSR",
      item2: "Are you sure you want to Discharge this PPSR?"
    },
    ppsrDetails: {
      errMsg: {
        item1: "Invalid country code. Supported countries are 'NZ' and 'AU'."
      },
      collatralType: "COLLATERAL TYPE: AAPP",
      description:
        "Description: All present and after acquired personal property and all other property including, without limit, all present and after acquired right title and interest to all accounts receivable and all proceeds thereof.",
      trusteeDescription: (trusteeName, trustName) =>
        `Description: All present and after acquired personal property and all other property including, without limit, all present and after acquired right title and interest to all accounts receivable and all proceeds thereof, of ${trusteeName} as trustee of the ${trustName}.`,
      debtorReference: "Debtor Reference",
      securedPartyReference: "Secured Party Reference",
      familyName: "FAMILY NAME",
      givenName: "GIVEN NAMES",
      corparate: "CORPARATE"
    }
  },
  ownerAddModal: {
    errMsg: {
      item1:
        "First name should only contain letters, spaces, hyphens and apostrophes",
      item2:
        "Last name should only contain letters, spaces, hyphens and apostrophes",
      item3: "Failed to add owner"
    },
    addNewOwner: "Add New Owner"
  }
};

export const trustCorporateTab = {
  errMsg: {
    item1: "Failed to add trust corporate",
    item2: "Failed to add trust",
    item3: "Are you sure you want to add a new corporate",
    item4: "Failed to add Corporate",
    item5: "Failed to delete trust corporate"
  },
  title: "Trust & Corporate Summary Comments",
  trustCommnt: "Trust Comments",
  trustDetails: {
    errMsg: {
      item1: "Trust name",
      item2: "Please input trust name.",
      item3:
        "Please add at least one Trustee before generating the guarantee file.",
      item4:
        "Please add at least one Trustee with both Name and Email before generating the guarantee file.",
      item5: "Email sent failed",
      item6: "Field must contain only alphabetic characters and spaces.",
      item7: "Please select an Agreement.",
      item8: "Trustee with uniqueId not found:",
      item9: "Trustee deleted successfully.",
      item10: "Error deleting trustee.",
      item11: "File delete successfully",
      item12: "Please select an Agreement option before uploading a file.",
      item13: "Unsupported file extension:"
    },
    trustName: "TRUST NAME",
    corporatPPSR: {
      errMsg: {
        item1: "Discharge PPSR",
        item2: "Are you sure you want to Discharge this PPSR?"
      },
      orgName: "Organisation Name:"
    }
  },
  corporateDetails: {
    errMsg: {
      item1: "Please input Corporate name.",
      item2:
        "Please add at least one Director before generating the guarantee file.",
      item3:
        "Please add at least one Director with both Name and Email before generating the guarantee file.",
      item4: "Please select agreement document.",
      item5: "Corporate deleted successfully.",
      item6: "Error deleting corporate.",
      item7: "Email cannot be the same as Director"
    },
    corporateName: "CORPORATE NAME",
    corporateCommnt: "Corporate Comments",
    directorEmail: "DIRECTORS EMAIL",
    companyAddrs: "COMPANY ADDRESS",
    notRequiredPlaceholder:
      "Please provide reason why guarantee is not required",
    notRequiredLabel: "Not Required Reason:"
  }
};

export const checkListTab = {
  title: "Sales",
  creditDecisionNote: "CREDIT DECISION NOTES",
  table: {
    td1: "Summary",
    td2: "Credit Limit",
    td3: "Funds Needed",
    td4: "Between",
    td5: "and"
  },
  questions: {
    td1: "QUESTIONS:",
    text1: "Question :",
    text2: "CUSTOMER RESPONSE:",
    fileDownloadSuccess: "File downloaded successfully",
    fileDownloadFailed: "Failed to downloading file"
  },
  selectQuestion: {
    th1: "SELECT QUESTIONS",
    addBtn: "ADD QUESTION",
    placeholder: "Enter your question here...",
    emailSendModal: {
      title: `Select "from email"`,
      paraGph: `DO YOU WANT TO SEND THE QUESTION TO THE BENEFICIAL OWNER'S EMAIL ADDRESS?`
    }
  },
  toolTip: {
    refreshAllBtn: "Refresh all",
    refreshDbBtn: "Refresh DB data only"
  }
};

export const tiptapEditor = {
  toolbarLabel: "Text formatting",
  fontSize: "Font size",
  fontSizeDefault: "Size",
  bulletList: "Bullet list",
  bold: "Bold",
  italic: "Italic",
  underline: "Underline",
  strike: "Strikethrough",
  outdent: "Decrease indent",
  indent: "Increase indent",
  horizontalRule: "Horizontal line",
  removeFormat: "Clear formatting",
  textColor: "Text colour",
  highlightColor: "Highlight colour",
  creditNotesPlaceholder: "Add credit decision notes…",
  creditNotesLabel: "Credit decision notes"
};

export const accSofywareName = {
  myob: "MYOB",
  quickBooks: "QuickBooks",
  reckon: "Reckon"
};

export const commentBox = {
  commentDeleteMsg: "Are you sure to remove this comment permanently?",
  commentAddText: "Comment",
  commentPlaceholderText: "Comment Here",
  commentAddBtnText: "ADD A NEW COMMENT",
  failedTosave: "Failed to save comment"
};

export const modalActionBtn = {
  excel: "EXCEL",
  pdf: "PDF",
  showOnScreen: "Show On Screen",
  apply: "Apply Now"
};

export const noResultsFound = "No results found";
export const noDataFound = "No data found.";
export const noDataAvailable = "No data available in table";
export const FtNo = "FT";
export const SearchText = "Search...";
export const Select = "Select";
export const SelectanEmail = "Select an Email";
export const processing = "Processing...";
export const sending = "Sending...";
export const clickHere = "Click Here";
export const email = "email";
export const auPhNumber = "1800 595 505";
export const auPhNumberTag = "1800595505";
export const nzText = "NZ:";
export const nzText1 = "or NZ:";
export const nzText2 = "NZ";
export const auText = "AU:";
export const ausText = "AUS:";
export const ausText1 = "AUS";
export const nzPhNumber = "0800 88 33 55";
export const nzPhNumberTag = "0800883355";
export const mail = "info@fundtap.co";
export const ph = "Ph:";
export const orSmall = "or";
export const egno = "013011 320051325";
export const companyName = "mejora Company";
export const TmFundTap = "Team FundTap";
export const InvoiceCmntRemove = "Invoice comment removed successfully";
export const fn = "FN";
export const ErrorText = "Error";

export const headerData = {
  admin: "Admin",
  administration: "Administration",
  myInvoices: "My Invoices",
  myAccount: "My Account",
  preQualification: "Pre-qualification",
  logout: "Logout",
  returnToAccount: "Return to My Account",
  setupAccount: "Set up my account",
  home: "Home",
  faqs: "FAQs",
  statements: "Statements"
};

export const fundedInvoicesData = {
  toFund: {
    toFundNav: "To Fund",
    title: "Funds to your account",
    content1: "FundTap can provide funds of",
    content2: "in your account",
    content3: "scroll down for more details",
    content4: "I have read and accepted the FundTap",
    content5: "Please accept the terms and conditions.",
    content6: "Want Funding?",
    content7: "Select 1 or more Invoices",
    content8: "Current Credit Limit:",
    content9: "Current Outstanding",
    content10: "Available for more Funding:",
    content11: "Request Credit Limit Review",
    content12: "Don't see the invoices you expected to?",
    content13: `Not ready to submit an invoice yet, but want some reassurance we
              can provide funding quickly in the future. Complete preapproval
              (it only takes 5-10 min).`,
    content14: "Have questions need help?",
    content15: `the FundTap team or call us: AU:`,
    content16: `or NZ:`,
    content17: "I have read and accepted the FundTap"
  },
  funded: {
    fundedNav: "Funded",
    filter: {
      title: "Select Invoice",
      all: "All Invoices",
      dueInvoice: "Due Now",
      pendingInvoice: "Pending Invoice"
    },
    newDate: "Set New Date",
    dueNow: "Due Now :",
    totalOwing: "Total Owing*:",
    totalOwing1: " Total Owing as at",
    text1:
      "*Total Owing includes invoices with a future payment date that are not yet due",
    text2:
      "Please make payment to our bank account and add the FT Number/s as the payment reference:",
    phNumber: "013011-3200-51325",
    subTotal: "Subtotal for"
  },
  btnGroup: {
    acceptQuote: "Accept Quote"
  },
  statusMessage: {
    msg1: "No invoices found for the current user.",
    msg2: "Invoice uploaded successfully",
    msg11: "Invalid software name. Please select a valid option.",
    msg13: " No invoices found"
  },
  manualUploadModal: {
    businessLegal: "Business Legal Name *",
    invNumber: "Invoice Number *",
    debtor: "Debtor *",
    issueDate: "Issue Date *",
    invTotal: "Invoice Total *",
    uploadInv: "Upload a copy of the invoice *",
    titleSingleInv: "Enter details for a single invoice.",
    accessor: "totalAmount"
  },
  BulkUploadErrorModal: {
    subTitle:
      "The following invoices were not uploaded as the due date is not current:",
    table: {
      format: "Expected format"
    }
  },
  ManualUploadInvInfo: {
    title: "Great news!",
    subtitle1:
      "FundTap have partnered to give you a discount on your fee today.",
    subtitle2: "See the fee box below for details."
  },
  CurrentOutStanding: {
    subtitle: `This figure only includes the amount FundTap has funded to you. It does not include the fee owing. Please see the `,
    subtitle2: ` page for details on the fee owing.`
  },
  CurrentOutStanding2: {
    subtitle: `This figure only includes the amount FundTap has funded to you. It does not include the fee owing. Please see the `,
    linkText: `Fundeds`,
    linkTo: "/",
    subtitle2: ` page for details on the fee owing.`
  },
  RequestCreditLimitModal: {
    amountRequest: "Amount Requested must be a positive number",
    supportingComment: "Supporting Comments cannot be empty",
    title:
      "Please inform us of the amount by which you would like to increase your credit limit. We will review the requested increase and notify you via email.",
    requstedAmount: "Amount Requested:",
    supportingCommnet: "Supporting Comments:",
    supportingPlaceholder: "Provide a short commentary",
    thankYouContent: "Your request has been successfully submitted. Thank You!"
  },
  SyncInvoiceModal: {
    text1: "Sync your invoices",
    text2: "by clicking the Sync Invoices button.",
    text3: "Only 10 invoices?",
    text4:
      "Change the number of invoices to be displayed, or click next. This can be found directly below the table displaying your invoices.",
    text5: "Your invoices must be current.",
    text6:
      "We can not fund past-due invoices. If an invoice has not been paid by your customer when expected, then it will be past-due and will not appear as available to be funded in your FundTap account.",
    text7: "Still not working?"
  },
  SyncInvoiceButton: {
    buttonLabel: "Upload Invoices",
    syncingLabel: "Syncing",
    defaultLabel: "Sync Invoices"
  },
  CashbookListModal: {
    title: "Select Book Name"
  },
  AcceptQuoteInvoiceModal: {
    text1:
      "Thanks, we've now received these and will process them for funding. If we need any additional information we'll be in touch.",
    outOfHoursNote:
      "FundTap operates 9am-5pm, Monday-Friday, and funds are not processed outside of these hours."
  }
};

export const promoComponent = {
  title: "Promo Code",
  promoCodePlaceholder: "Enter Promo Code"
};

export const commonValidationMsg = {
  dateChange: "Only invoices with a future due date can be funded.",
  fileLimitError: "File size exceeds the 5MB limit.",
  legalName: "Business Legal Name is required.",
  invNumber: "Invoice Number is required.",
  debtorName: "Debtor Name is required.",
  invTotal: "A valid Invoice Total is required.",
  invcopy: "Please upload a copy of the invoice.",
  issueDate: "Issue Date is required.",
  dueDate: "Due Date is required.",
  issueDateSame: `"Issue date" and "Due date" cannot be the same.`,
  reportDate: "Please select report date!",
  wishProced: "Do you wish to proceed?",
  fileUpload: "Please select a file before submitting.",
  selectPermission: "Please select at least one permission.",
  permissionName: "Permission name is required",
  endpointRequired: "Endpoint is required"
};

export const repaymentDateAlert = {
  title: "Repayment date change",
  subtitle: "Are you sure you want to change the repayment date?",
  payReportSubtitle:
    "Already scheduled, still you want to change the repayment date?"
};

export const statusBtn = {
  Success: "Success",
  Pending: "Pending",
  Failed: "Failed"
};

export const invcsConnect = {
  errMsg: {
    item1: "Error during authorization:"
  },
  connectInvcs: "Connect Your Invoices",
  clickOnYour:
    "Click on your accounting provider for instant access to FundTap",
  unSure: "Unsure how to get set up?",
  chatToOur:
    "Chat to our onboarding specialists who can walk you through step-by-step.",
  wetakeUour:
    "We take your privacy seriously. FundTap encrypts your data and will never share your financial data with anyone else.",
  invoManualText: {
    dontUse: "Don't use any of these accounting providers?",
    clickToUoload: "Click to Upload Invoices",
    useGa4: {
      errMsg: {
        item1: "GA4 tracking error (attempt",
        item2: "Max retry attempts reached for event:",
        item3: "Missing user in signup properties",
        item4: "Missing client_id for login event",
        item5: "Invalid quotes array in submit invoice properties",
        item6: "Missing invoice number in manual upload properties",
        item7: "Missing user ID for Xero connect event",
        item8: "Missing user ID for MYOB connect event",
        item9: "Missing user ID for QuickBooks connect event",
        item10: "Missing user ID for Reckon connect event",
        item11: "Missing user ID for pre-approved status event",
        item12: "Missing user ID for approved status event",
        item13: "Missing user ID for ID verification event",
        item14: "Missing required parameters for funded invoice event",
        item15: "Invalid quotes array in demo invoice properties",
        item16: "Missing user ID for engagement event",
        item17: "Missing user ID or file name for download event"
      }
    }
  },
  xeroModal: {
    title: "Link Your Xero Invoices",
    text1:
      "To provide Invoice Finance we’ll need to access your Xero Organisation data and User account information. This access will be ongoing, but you may revoke our access through either your FundTap or your Xero",
    text2:
      "You may revoke this access at anytime you do not have lending outstanding to us. If you have lending outstanding then as part of the FundTap Agreement we do require this access. So we can automatically keep your data in Xero up to date we’ll share the records required of your FundTap transactions with Xero. The data we share with Xero will be stored in your Xero organisation and subject to Xero’s terms of use.",
    text3: "Don't hesitate to get in touch with us if you have any questions."
  },
  netWorkStatus: {
    noNetwork: "No network connection. You are offline!",
    backOnline: "You are back online!"
  }
};

export const networkProvider = {
  error: "useNetworkCheck must be used within a NetworkProvider"
};

export const verifyEmail = {
  success: "Email Verified Successfully",
  success1: "Success! The email has been updated successfully.",
  text: "Please wait while we verify your email...",
  error: "Email Verified failed :"
};

export const invalidEmailOrToken = {
  text: "Invalid or missing email and/or token."
};

export const demoAccount = {
  p1: "Click on a demo invoice (or invoices) and submit. It's that easy to get funded with FundTap.",
  p2: "Once your done, you can Please enter this here:complete your sign up by clicking on 'Set Up My Account', or just keep playing with the demo.",
  p3: `It's as easy as that!`,
  p4: `If this was one of your real invoices - We'd now ask for
    some details such as ID information. You'd then receive
    cash into your bank account within a few hours.`,
  p5: `To get started, just click Set Up My Account:`,
  p6: "Welcome to the FundTap Demo!",
  p7: `First step is to connect your invoices by clicking on the
      accounting software you use (Don't worry, it won't
      actually connect in this demo).`,
  title: "My Invoices",
  linkText: "Set Up My Account",
  linkText1: "Book a Demo with Us",
  btnText: "Keep Playing"
};

export const aboutSignUpContent = {
  left: {
    p1: "The difference between going directly to the bank and using FundTap was huge. No time-wasting, no lengthy applications – just approval and results. Partnering with FundTap was one of the best decisions I have ever made. With the funding I got I now have the flexibility to grow the business exactly the way we want.",
    title: "Rehan",
    subH2: "Reliable Plant Solutions"
  },
  right: {
    h2: "Get Started For Free",

    p1: "Sign-up to get On-Demand finance now",
    inputGroup: {
      btnText: "Get Funding",
      btnNote:
        "By signing up, you agree to receive important notices regarding the use of FundTap"
    }
  },
  content: "Get Started"
};
export const signAgreementContent = {
  titles: {
    annature: "You have already reviewed and signed digitally the FundTap",
    sub1: "Manually",
    annatureSub: "using Annature.",
    manual: "Please review & sign the FundTap",
    instructions: "Instructions:",
    heading:
      "You will need to digitally sign on the front page and have three witness digitally sign."
  },
  email: {
    contact: "If you have any questions, don't hesitate to get in contact with",
    address: "FundTap at",
    help: "If you have any problems you can email this file to"
  },
  buttons: {
    digitalSign: "Review and Sign Digitally",
    manualUpload: "Sign and Upload Manually"
  },
  labels: {
    uploadLater: "Upload Later"
  },
  instructions: {
    TrustGuarantee1: "1) Please download the ",
    TrustGuarantee2: "2) Directors need to initial each page and sign.",
    TrustGuarantee3: "3) Upload this signed file using the Upload button.",
    TrustGuarantee4: "4) Click the Confirm button - you are all done.",
    TrustGuarantee5:
      "1) Please download the FundTap Agreement, sign and initial each page."
  }
};

export const uploadDoc = {
  note: `Please review & sign the FundTap agreement. You will need to
digitally sign twice on the front page and have a witness
digitally sign.`,

  manualSection: {
    instruction1: `Please download, review and sign the FundTap Agreement. A
witness and yourself need to sign on the 1st page. You can then
upload this signed file using the Upload button. Once you click
the Confirm button, and you are all done.`,

    instruction2: `If you have any problems you can email this file to`,

    downloadLabel: "Download FundTap Agreement",
    uploadLabel: "Upload FundTap Agreement"
  }
};

export const kpiReportText = {
  labels: {
    syncXero: "Sync Xero data :",
    pipeDriveLeads: "PipeDrive Leads Count :",
    lastUpdated: "Last updated Aug 01, 2025, 10:43 AM",
    kpiLastUpdated: "Last updated ",
    btn: "Refresh Kpi Report"
  }
};

export const accSetting = {
  reckonText: "Reckon liability accounts do not require a tax code.",
  myobText: "Myob liability accounts do not require a tax code.",
  xeroText: "Xero liability accounts do not require a tax code.",
  taxCodeText: "Tax code information unavailable.",
  step3Title: "Step 3: Accounting Settings",
  applyIdp1:
    "FundTap does the admin work for you by creating and reconciling the FundTap Transactions in your",
  applyIdp2: "account. Click the Save & Continue button to create new",
  applyIdp3:
    "accounts for FundTap transactions, or select one of your existing",
  applyIdp4: "accounts.",
  moreDetails: "More details...",
  selectExpense: "Select an Expense account",
  createExpense: "Create an Expense account",
  taxCode: "Tax Code",
  tooltipContent1: "GST is not charged on FundTap advances or fee",
  code: "Code",
  orSelect: "or Select an existing Expense account",
  selectCurrent: "Select a Current Liability account",
  selectLiability: "Select a Liability account",
  createCurrent: "Create a Current Liability account",
  orSelect2: "or Select an existing Current Liability account",
  onboardingModal: {
    title:
      "Fixing your cash flow and funding your business should be easy. Why should it be difficult, complicated or time consuming for you?",
    p1: "By creating or selecting existing",
    p2: "accounts here you allow our system to automatically create the accounting entries for you to match in",
    p3: "when they happen. You still maintain all control of how you account for our advance and fee, but the heavy lifting has been done for you.",
    li1: "Current Liability Account: The account you create or select here will be the Current Liability account that will account for the cash advances you receive from FundTap. This is the same as any other short term loan and provides a record for yourself of what is owed to FundTap within your",
    li2: "accounts. Once repayment of our advance is made, this loan (Current Liability) account is returned to $0.",
    li3: "Expense Account: The Expense Account you create or select here will keep a record of the fee you pay to FundTap for each invoice we fund. You can keep tabs on the fee you pay both in",
    li4: "and in your FundTap account."
  },
  otherOwnercontent: `Once you have added all owners, or you are the sole owner, please click "Next Step" below:`
};

export const agreementTexts = {
  step4text: "Step 4: Agreement",
  pleaseReview: "Please review & sign the FundTap",
  youWill:
    ". You will need to digitally sign twice on the front page and have a witness digitally sign.",
  reviewSign: "Review and Sign Digitally",
  signUpload: "Sign and Upload Manually",
  pleaseDownload:
    "Please download, review and sign the FundTap Agreement. A witness and yourself need to sign on the 1st page. Then click the upload button to submit this signed agreement.",
  youComplete: `You can complete this step at another time. Click the "Upload Later" checkbox to be emailed a copy of this agreement to complete at a later date.`,
  downloadAgreement: "Download FundTap Agreement",
  uploadAgreement: "Upload FundTap Agreement",
  modal: {
    title: "Review and digitally sign the FundTap Agreement",
    signDocumentTitle: "Sign Document: Fundtap Agreement",
    signingUnavailable:
      "We could not open the signing session for this document. Please close this window and try again, or contact support if it keeps happening."
  },
  p1: `Hi Test,
Please review and sign the FundTap agreement. You will need to
digitally sign twice on the front page and have a witness sign.
Much appreciated,`,
  p2: `By clicking "Review document", I agree to conduct business
electronically with FundTap, and I accept the terms of the `,
  link1: "Annature Electronic signature disclosure",
  link2: "Acceptable use policy",
  tcGuarntee: {
    title: "FundTap Agreement",
    doYouOwn: "Do You Own This Property:?"
  },
  uploadDocsText:
    "Please download, review and sign the FundTap Agreement. A witness and yourself need to sign on the 1st page. You can then upload this signed file using the Upload button. Once you click the Confirm button, and you are all done.",
  uploadDocsText_1: "If you have any problems you can email this file to",
  uploadDocsText_2: "or contact us on",
  uploadDocsSuccessText: `Thanks! You're all set. You can close this browser window now.
If you have any questions, don't hesitate to get in contact with
FundTap at`
};

export const tcAgreementTexts = {
  instruction: "Instructions:",
  instructionContent1:
    "1) Please download the FundTap Guarantee, sign and initial each page.",
  instructionContent2: "2) Upload this signed file using the Upload button.",
  instructionContent3: "3) Click the Confirm button - you are all done."
};

export const bankDetls = {
  errMsg: {
    item1: "Business Name is required.",
    item2: "Select a bank account.",
    item3: "Select a Legal Business Structure.",
    item4: "Bank Account is required.",
    item5:
      "Bank Account should contain numbers only and must not include letters or special characters.",
    item6: "Please confirm the bank account number.",
    item7: "Property ownership status is required.",
    item8: "Property Owned Address is required.",
    item9: "Accountant Firm is required.",
    item10: "Accountant Name is required.",
    item11: "How you heard about FundTap is required.",
    item12: "Please specify how you heard about FundTap.",
    item13: "Select a bank account or input manually."
  },
  step2Title: "Step 2: Bank Details",
  bankAccRcv: "Bank account to receive funds",
  letusKnow: "Let us know which bank account we should deposit funding to.",
  iConfirm: "I confirm the bank account number above is correct.",
  bankAccNumber: "Bank Account Number",
  enterBank: "Enter the bank account number for the account specified above.",
  legalBsnsName: "Legal Business Name",
  legalBsnsStructure: "Legal Business Structure",
  canFundtap: "Can FundTap contact your accountant?",
  accFirm: "Accountant Firm",
  doYouOwn: "Do You Own This Property?",
  doYouOwn2:
    "Do you own the property that you entered in the APLYiD ID verification process?",
  howYouHear: "How did you hear about FundTap?",
  plsSelect: "Please select",
  google: "Google",
  facebook: "Facebook",
  accAdvisor: "Accountant/Advisor",
  fromFundtap: "From a FundTap Client",
  otherPlsSpcfy: "Other (please specify)",
  othersSpecify: "Others - (Specify)",
  pleaseSpecify: "Please specify"
};

export const directDebit = {
  errMsg: {
    item1: "User ID not found",
    item2: "Some requests failed. Please try again.",
    item3: "Failed to submit data. Please check your inputs and try again."
  },
  step6Title: "Step 6: Direct Debit Authority",
  lastStep:
    "Last step! Click the button below to complete a direct debit authority. This automates repayments to FundTap when your customer pays you."
};

export const identityText = {
  errMsg: "Please check the consent checkbox before proceeding.",
  step1title: "Step 1: Verify Your Identity",
  moreHelp: "more help?",
  weCouldn: "We couldn't generate the QR code. Please reload the page.",
  completeOnMobile: "Complete on your Mobile device",
  ifYou: "If you are on a mobile device with a camera click to continue:",
  continueMobile: "Continue on Mobile",
  completeOnDesktop: "Complete on your desktop",
  ifUsing:
    "If using a desktop device you can either scan the QR code or click the button below.",
  sendLink: "Send Link to my Phone",
  onceYou:
    "Once you have fully completed your ID check, this page will update - it may take 30 seconds, so please don’t navigate away.",
  useAdditionalComp: {
    theWhole:
      "The whole application process will only take 5-10 min. The first step is to confirm your identity.",
    iConsent: "I consent to FundTap obtaining",
    pleaseScan:
      "Please scan the QR code using your mobile phone OR click the button to verify your Identity.",
    creditandUdentity: "credit and identity checks"
  },
  onboardingIntgModal: {
    thismayTake: "This may take 30 seconds, please do not refresh the page",
    enterYourPh: ` Enter your phone number to be sent a text message with a link to
      verify your identity.
    `
  },
  onboardingIntInfogModal: {
    inOrder:
      "In order for FundTap to undertake and execute searches and checks on you and/or your trading entity or any other entities related to you, including (without limitation) credit, identity, property, address and anti-money laundering checks and searches. You authorise FundTap to undertake, or engage third parties to conduct the above Investigations on its behalf. You authorise FundTap to pass any personal information to third parties for the purpose of executing the above Investigations.",
    pleaseConact:
      "Please contact us if you need further information or have any questions:",
    fundTap: "FundTap Contact Details.",
    email: "email:"
  },
  tokenExpiredText: "The link has expired or is invalid."
};

export const addquestionsWrap = {
  text: "Can you please confirm if you are operating as a sole trader or under a company structure? If you use a company structure can you please confirm the full legal name of your business entity?"
};

export const syncBtn = {
  buttonLabel: "Upload Invoices",
  syncingLabel: "Syncing",
  defaultLabel: "Sync Invoices"
};

export const tellfriendModal = {
  title: " Tell A Friend URL",
  text: " https://secure.fundtap.co/tell-a-friend?referrer=Mercia&amp;referrerURL=https%3A%2F%2Fsecure.fundtap.co%2Freferral-sign-up%2F4359%2F46%2F2537"
};

export const craditModal = {
  errMsg1:
    "Please provide a valid positive number for the Amount Requested field and ensure that the value you provided is greater than your current credit limit.",
  errMsg2: "The Supporting Comments field is mandatory.",
  text: `Please inform us of the amount by which you would like to increase your
        credit limit. We will review the requested increase and notify you via
        email.`
};

export const callBackComp = {
  doNotRefresh: " Please do not refresh this page...",
  text1: "Redirecting from FundTap to APLYiD",
  xeroCall: {
    text: "Xero Software Connected Successfully"
  }
};

export const customerStatementModal = {
  greeting: "Hi",
  invoiceDetails:
    "Please see the details below of the invoices and the amounts owing as of today.",
  manualPaymentNote:
    "If the direct debit date is not within the next business day, please reply to this email to confirm your manual payment and include a screenshot of the payment. This will help us cancel the direct debit in time. Without your confirmation, the direct debit may still be processed, potentially leading to a duplicate payment.",

  depositInstructions: {
    text1: "Please deposit into the following bank account –",
    text2: "Please quote your FT number/s as the payment reference.",
    accountLabel: "Seascape (2010) Limited t/a Fundtap:",
    accountNumber: "02-0192-0532860-00"
  },

  closing: {
    thankYou: "Thank you",
    teamName: "Team FundTap"
  },

  contact: {
    website: "www.fundtap.co"
  }
};
export const userReports = {
  monthlyLendingReport: {
    text1: "Monthly Lending Report",
    text2: "Amount",
    text3: "Days",
    titleCumulative: "Monthly Lending Report (Cumulative)",
    titlePerDay: "Monthly Lending Report (Funds per Day)",
    biggestDayTag: "★ Biggest day of the month"
  },
  ltvReport: {
    text1: "LTV Report",
    text2: "Periods"
  }
};

export const customerStatement = {
  text1:
    "Please see the details below of the invoices and the amounts owing as of today.",
  text2:
    "If the direct debit date is not within the next business day, please reply to this email to confirm your manual payment and include a screenshot of the payment. This will help us cancel the direct debit in time. Without your confirmation, the direct debit may still be processed, potentially leading to a duplicate payment."
};

export const bankFileModal = {
  title: "Click on Reload after file download",
  text: "The bank file is being generated. Once the file is downloaded, please click the reload button to refresh the page"
};

export const refferalPartnerURL = {
  bannerSection: {
    heading: "FundTap provides the fastest source of",
    sub1: "cashflow available",
    sub2: " – paid in hours.",
    content: "Get Started"
  },

  signupWrapSection: {
    p1: "Rehan M",
    p2: "Reliable Plant Solutions",
    sub1: "Get",
    sub2: "Started",
    sub3: "For Free",
    p3: "Sign-up to get On-Demand finance now",
    btnText: "Create Free Account",
    p4: "By signing up, you agree to receive important notices regarding the use of FundTap",
    formPlaceholders: {
      firstName: "First Name",
      lastName: "Last Name",
      businessEmail: "Business Email",
      password: "Create a Password"
    }
  },

  customerTestimonial: {
    heading: "Helping customers sleep better for 12 years",
    testimonial1: {
      heading: "Glassforce",
      company: "Glassforce",
      content:
        "FundTap is like a lifeline to your business. It's a fantastic boost that will get you to your next step."
    },
    testimonial2: {
      heading: "Matt E",
      company: "Graffic",
      content:
        "FundTap gives me added control over this and is incredibly efficient and easy to use. Highly recommended!"
    },
    testimonial3: {
      heading: "Stuart W",
      company: "Gralich Compliance Management",
      content:
        "Excellent service. Easy to connect and get started, great communication from the team without being pushy."
    },
    testimonial4: {
      heading: "Gary M",
      company: "NYA Cake Guys",
      content:
        "They took the time to understand our unique business requirements, without being pushy, great service."
    },
    testimonial5: {
      heading: "Glenn D",
      company: "e3 Scientific",
      content:
        "Great service with a professional team. FundTap does a great job at plugging the gap for small businesses and providing confidence to make decisions regarding business growth."
    },
    testimonial6: {
      heading: "Gabrielle B",
      company: "Glassforce",
      content:
        "FundTap is like a lifeline to your business. It's a fantastic boost that will get you to your next step."
    },
    testimonial7: {
      heading: "Sarah H",
      company: "YUM Foods",
      content:
        "We love the convenience and accessibility of FundTap. It's simple which is really nice and has enabled us to do things we wouldn't otherwise."
    }
  },

  whyChooseSection: {
    heading: "Why do our customers love",
    headingBold: "FundTap?",
    feature1: {
      heading1: "Get started",
      heading2: "in minutes",
      content:
        "With integrations to the top accounting software – it takes minutes to get going."
    },
    feature2: {
      heading: "The fastest access to funds",
      content:
        "It's the fastest source of finance – paid into your bank account in hours."
    },
    feature3: {
      heading: "No changing bank accounts",
      content:
        "No change to how you invoice or collect payments. Your customers won't know."
    }
  },

  workSection: {
    heading: "How it",
    headingBold: "works",
    step1: "Connect Your Accounting Software",
    step2: "Select Your Invoice(s)",
    step3: "Receive Cash Within Hours",
    step4: "Repayment Is Automated",
    demoBtn: "View Demo"
  },

  partnerSectionWrap: {
    heading: "Our trusted partners",
    subHeading: "Check out our integrations with our accounting partners."
  },

  compareSection: {
    heading: "How does it",
    headingBold: "compare",
    tab1: "FundTap",
    tab2: "Online Invoice Finance",
    tab3: "Traditional factoring",
    tableHeader1: "",
    tableHeader2: "FundTap",
    tableHeader3: "Online Invoice Finance",
    tableHeader4: "Traditional factoring",
    row1: {
      feature: "Easy to establish",
      fundTap: "tick",
      onlineInvoice: "cross",
      traditional: "cross"
    },
    row2: {
      feature: "Online and mobile",
      fundTap: "tick",
      onlineInvoice: "tick",
      traditional: "cross"
    },
    row3: {
      feature: "Link to Accounting System",
      fundTap: "tick",
      onlineInvoice: "tick",
      traditional: "cross"
    },
    row4: {
      feature: "Application approval",
      fundTap: "1 hour",
      onlineInvoice: "48 hours +",
      traditional: "2 weeks +"
    },
    row5: {
      feature: "Quick funding",
      fundTap: "Minutes",
      onlineInvoice: "Days",
      traditional: "Days"
    },
    row6: {
      feature: "No Establishment fees",
      fundTap: "tick"
    },
    row7: {
      feature: "No Admin or System fees",
      fundTap: "tick"
    },
    row8: {
      feature: "Debtor pays to normal account",
      fundTap: "tick"
    },
    row9: {
      feature: "Use only when needed, without penalty",
      fundTap: "tick"
    },
    demoBtn: "View a Demo"
  }
};

export const financialReportTable = {
  tableData: {
    data1: "Total Current Assets",
    data2: "Total Assets",
    data3: "Total Current Liabilities",
    data4: "Current Year Earnings"
  }
};

export const updateStatusModalData = {
  sub: "Are you sure? This state move should only be done to fix an error.",
  sub2: "Confirm change of status Invoice",
  sub3: "Funding these invoices will bring the total funding of",
  stattus: "Status:",
  placeholder: "Please enter reason here..."
};

export const editableClick = {
  editable: ".editable",
  selected: ".selected"
};

export const tooltipContent = {
  generateReportDownload: "Generate New Report ",
  reportDownload: "Report Download",
  bulkdata: "Bulk Data",
  zipFile: "Zip File",
  upload: "Upload",
  add: "Add",
  edit: "Edit",
  sendEmail: "Send Email",
  emailUpdate: "Email update",
  content:
    "You can request to change the Repayment Date anytime up to 5 days after the Invoice Due Date.",
  content1:
    "You can request to change the Repayment Date anytime prior to an Invoice Due Date (this will reduce your fee) or up to 5 days after the Invoice Due Date.",
  syncData: "Sync Data",
  download: "Download",
  searchFinancingStatements: "Search Financing Statements"
};

export const commonPlaceHolderText = {
  placeholder_1: "e.g. 100000"
};

export const InvoiceAllDetails = {
  title_invoice: "Invoice Details",
  title_customer: "Customer Details",
  all: "All",
  Custom: "Custom",
  customerTypeMap: "customerTypeMap",
  lending: "lending",
  customer: "customer",
  customers: "customers",
  InvoiceDetails: "Invoice Details"
};

export const faqText = {
  FrequentlyAsked: ` Frequently Asked `,
  Questions: ` Questions `,

  faqAccordian1: {
    id: "faq-1",
    question: "Can I change my direct debit date?",
    answer: `Yes, you can extend your direct debit date by up to 5 days by changing the repayment date on the “funded” tab of your “my invoices” page, accessible from the dropdown menu. Please ensure any changes are made at least 1 business day before the due date.`
  },

  faqAccordian2: {
    id: "faq-2",
    question: " What if I need more time than 5 days?",
    answer: `If you need to extend the date by more than 5 days, please email us at info@fundtap.co with your requested new date and proof of communication with your client confirming the invoice will be paid at the later date.`
  },
  faqAccordian3: {
    id: "faq-3",
    question: "Can I repay early?",
    answer: `Yes, you can repay early by making a manual payment to us at [FT BANK ACCOUNT NUMBER]. Please complete this at least 2 business days before the due date to ensure the direct debit is cancelled. You can see your balance owing today on your “my invoices” page.`
  },
  faqAccordian4: {
    id: "faq-4",
    question: "  I changed my bank account number, what do I do?",
    answer: `Please email us at`,
    email: ` info@fundtap.co `,
    text: `with your new bank account details, and we will send you a link to update your direct debit mandate. If you use Xero, make sure to update your bank account information there as well.`
  },
  faqAccordian41: {
    id: "faq-41",
    question:
      " The direct debit went out, but it isn’t showing as paid in my portal. Why?",
    answer: `There is a 2-3 day delay in when the direct debit occurs and when it is settled with the banks. You can still request funding during this time. If it marks it as being over your facility limit, you will receive an email asking for proof of payment. Please follow the instructions in the email and send through a screen shot of the direct debit to info@fundtap.co`
  },

  faqAccordian5: {
    id: "faq-5",
    question: ` I made a manual payment, but my FundTap account isn’t updated. Why?`,
    answer: `It takes up to 24 hours for manual payments to be reconciled. You can still request funding during this time. If it marks it as being over your facility limit, you will receive an email asking for proof of payment. Please follow the instructions in the email and send through a screen shot of the direct debit to info@fundtap.co`
  },

  faqAccordian6: {
    id: "faq-6",
    question: ` What happens if my client hasn’t paid and the direct debit is going to bounce?`,
    answer: `If you are aware at least 1 business day in advance that the direct debit will bounce, you can extend the repayment date by up to 5 days by changing the date on the “funded” tab of your “my invoices” page, accessible from the dropdown menu. If you have already used this option and need additional time, please contact us at`,
    email: `info@fundtap.co`,
    text: ` with your requested new date and proof of communication with your client confirming the new payment date`,
    subText: `If it is already the due date, email us to inform us of the situation. We value clear communication. Once it dishonours, you will also receive an automated email notifying you of the dishonored direct debit and the next steps to take.`
  },

  faqAccordian7: {
    id: "faq-7",
    question: ` My direct debit dishonoured, what happens now?`,
    answer: `You will receive an automated email outlining your next steps. This email will provide two options: instructions for making a payment today or, if your customer has not yet paid you, a request to inform us of the date you plan to make the payment.`
  },
  faqAccordian8: {
    id: "faq-8",
    question: ` Will my invoice be funded if it exceeds my credit facility?`,
    answer: `If funding the total invoices you have submitted will exceed your limit, we can fund a portion of the invoices, up to your credit limit.`
  },
  faqAccordian9: {
    id: "faq-9",
    question: ` What if I only need part of the invoice funded?`,
    answer: `When submitting your invoice, there is a comment section for the funding team. Enter the specific amount you need funded in that space.`
  },
  faqAccordian10: {
    id: "faq-10",
    question: `My invoice wasn’t approved. Why?`,
    answer: `If the invoice is not approved, you will receive an email with the reason why. Common reasons are that you do not have enough remaining in your credit facility, the invoice due date is greater than 60 days, or we need updated documents from you before we can fund.`
  },
  faqAccordian11: {
    id: "faq-11",
    question: `I need more funding, but I'm at my limit. Can you still help?`,
    answer: `Depending on your situation, we may be able to increase your credit facility. Please note that for limits over $30K, property will be required as security. You can request a credit limit review from your “my invoices” page.`
  },

  faqAccordian12: {
    id: "faq-12",
    question: `What data do you store from my accounting system?`,
    answer: `FundTap stores invoice data for the invoices that you submit to us for funding. This includes:`
  },

  faqAccordian13: {
    id: "faq-13",
    question: `How do you keep my data secure?`,
    answer: `All data is securely encrypted in transit and at rest. Our data security practices are subject to regular review and assessment by API providers (Xero, QBO, BNZ etc.), and must comply with the relevant security standards across both accounting and banking industries.`
  }
};

export const validatePhoneNumberTxt = {
  errorMsg: {
    nzPhRequired: "Enter valid NZ phone number (+64XXXXXXXXX)",
    auPhRequired: "Enter valid AU phone number (+61XXXXXXXXX)",
    startNzAu: "Phone number must start with +64 (NZ) or +61 (AU)"
  }
};

export const optimizationTexts = {
  addAnotherBtn: "Add Another Owner",
  first: "First",
  last: "Last",
  nameRequired: "name is required.",
  mustBeAtLeast: "Must be at least 2 characters long.",
  mustNotContain: "Must not contain spaces or special characters.",
  quickBooksSoftware: "QuickBooks Software Connected Successfully",
  fileUploaded: "File Uploaded Successfully"
};

export const monthlyKPIReportsData = {
  newLeads: "New Leads",
  customersFunded: "Customers Funded",
  lending: "Lending",
  lendingCustomer: "Lending/Customer",
  futureRevenue: "Future Revenue",
  collectedRevenue: "Collected Revenue",
  referrals: "Referrals",
  countries: "Countries",
  preapproved: "Preapproved",
  signedUp: "Signed-up",
  linkedAccounting: "Linked Accounting",
  submittedInvoice: "Submitted Invoice",
  NZFunded: "NZ Funded",
  AUFunded: "AU Funded",
  NZShare: "NZ Share",
  AUShare: "AU Share",
  newClients: "New Clients",
  partnerReferral: "Partner Referral",
  customers: "Customers",
  new: "New",
  preapprovedFunded: "Preapproved Funded",
  returning: "Returning",
  notTransacted_Approved: "Not Transacted_Approved",
  revenue: "Revenue",
  revenueCustomer: "Revenue/Customer",
  toolTip: {
    data1: "# Signed-up in this time period",
    data2:
      '# of new "Signed up" customers that linked their accounting system (% of Signed-up)',
    data3:
      '# of new "Signed up" customers that submitted an invoice (% of Signed-up)',
    data4:
      "# count any customers that move into state “preapproved” during that month",
    data5: "$ amount of invoices funded to NZ customers",
    data6: "$ amount of invoices funded to AU customers",
    data7: "% share of NZ funded invoices",
    data8: "% share of AU funded invoices",
    data9: '$ value of amount advanced for all invoices "Funded"',
    data10: "Total number of New Clients from Referrals funded that month",
    data11:
      "Number of different referral partners who have ‘signed up’ a client for that month",
    data12: '# of customers with at least 1 "Funded" invoice',
    data13:
      '# of new "Signed up" customers with at least 1 "Funded" invoice. (% of Signed up) [% of Submitted Invoice]',
    data14:
      "# count customers that move from state “preapproved” to “approved” during that month",
    data15:
      "# count customers that move from state “preapproved” to “approved” during that month",
    data16: '# of existing customers with at least 1 "Funded" invoice',
    data17:
      '# of existing customers (at least 1 "Funded" invoice in the past) that we did not fund in this time period.',
    data18: `Average Lending per customer in this time period. = Lending / Customers`
  },
  downloadModal: {
    notGenerated: "Not generated yet",
    notification:
      "Download file generation started, please come back after 10-15 minutes.",
    leadSource: "Lead Source",
    referralTypes: "Referral Types",
    salesLeads: "SalesLeads",
    withPercent: "With Percentage",
    refreshKpiReport: "KPI report refresh request",
    refreshAIReport: "AI report refresh request",
    text1: "Your KPI report refresh request has been received.",
    text2:
      "Please note that generating the monthly report for all country may take up to",
    text3: "Process started",
    text4: "A KPI report request is already in progress or pending.",
    text5: "Please wait 2 minutes until it is completed.",
    text6: "Previous time taken:",
    text7: "Process started",
    text8:
      "Monthly KPI report for the All country will begin shortly. Please note, the process may take up to 7 seconds.",
    text9: "AI report request is already in progress or pending.",
    text10: "Process started 0 minute ago."
  }
};

export const Inputfieldvalidation = {
  errorMsg: {
    emojiNotAllowed: "Emojis are not allowed",
    legalNameMaxLength: "Legal name should not exceed 30 characters",
    maxLengthChar: "Maximum length is 200 characters.",
    tradingNameMaxLength: "Trading name should not exceed 30 characters",
    companyNumberMaxLength: "Company number should not exceed 50 characters",
    acnError: "ACN must contain only digits",
    acnLength: "ACN must be exactly 9 digits",
    commentMaxLength: "Comment must be 500 characters or less.",
    promoCodeMaxLength: "Promo code must be 16 characters or less.",
    comment: "comment",
    firstNameLength: "First name must be between 2 and 50 characters",
    lastNameLength: "Last name must be between 2 and 50 characters",
    passwordLength: "Password must be between 8 and 50 characters",
    passwordStartWithPart: "Password should not start with first name or email",
    emailMaxLength: "Email address should not exceed 100 characters",
    commentsTooLong: "Comments too long",
    emailIsLong: "Email is too long",
    postalCodeLength: "Postal code must be exactly 4 digits",
    postalCodeDigits: "Postal code must contain only digits",
    postalCodePlaceholder: "Enter 4 digits",
    failedToLoadComments: "Failed to fetch comments",
    enterContactNumber: "Please enter a valid phone number.",
    stateAllowes: "Only allowed states: NSW, QLD, WA, SA, NT, ACT, TAS, VIC"
  }
};

export const emailTemplateGocardless = {
  dateForPayment: {
    title: "Date for Payment",
    text1:
      "Please let us know the date you expect your customer will pay. We will then email you a revised total along with our bank details for you to repay manually on that date:",
    paymentDateLabel: "Expected Payment Date:",
    paymentDatePlaceHolder: "Choose Date",
    paymentCommentPlaceLabel:
      "A short commentary on why the payment is delayed:",
    paymentCommentPlaceHolder: "Provide a short commentary",
    text2: "If you have any questions don't hesitate to email us,",
    text3: "or you can",
    text4: "call on",
    fileUploadLabel: "Upload Evidence",
    infoText: "Choose a date between tomorrow and 60 days from today.",
    infoTitle:
      "Because this date is more than 4 days from now, kindly consider the following:"
  },
  paymentNow: {
    title: "Please pay",
    title1: "to our account today:",
    text1:
      "Thanks for making payment today. Please upload bank payment confirmation here:",
    bankLabel: "Upload Bank Confirmation",
    text2: "Much appreciated",
    text3: "The FundTap Team",
    errorTitle: "The link has become invalid due to its expiration.",
    errorText:
      "If you have any questions, don't hesitate to get in contact with FundTap at"
  }
};

export const onboardingStepData = {
  step1: "Step 1: Verify Your Identity",
  step2: "Step 2: Bank Details",
  step3: "Step 3: Accounting Settings",
  step4: "Step 4: Agreement",
  step5: "Step 5: Other Owners",
  step6: "Step 6: Direct Debit Authority",
  withoutConnected: {
    step3: "Step 3: Agreement",
    step4: "Step 4: Other Owners",
    step5: "Step 5: Direct Debit Authority"
  },
  annatureAndAccountConnected: {
    step3: "Step 3: Accounting Settings",
    step5: "Step 4: Other Owners",
    step6: "Step 5: Direct Debit Authority"
  },
  annatureConnected: {
    step5: "Step 3: Other Owners",
    step6: "Step 4: Direct Debit Authority"
  },
  agreement: "Agreement"
};

export const ppsrValidation = {
  error1: "Firstname must be provided.",
  error2: "Lastname must be provided.",
  error3: "A personal address must be provided.",
  error4: "Date of birth must be provided.",
  error5: "A city or town or state must be provided.",
  error6: "Entity name must be provided.",
  error7: "NZBN number must be provided.",
  error8: "NZBN business address must be provided.",
  error9: "Add the organization name from the Customer tab.",
  error10:
    "The trust needs at least one individual trustee with a first name and a last name."
};

export const errorBoundaryFallback = {
  common: {
    listFallback: {
      text1: `Something went wrong while loading this section.`,
      reloadLink: `Refresh `,
      text2: `the page or try again later. If the issue continues, please contact support.`
    }
  },
  tableFallback: {
    text1: "We couldn’t load this section.",
    reloadLink: "Refresh",
    text2: "the page or try again. If the problem continues, contact support."
  },
  appFallback: {
    title: "Something went wrong.",
    subtitle:
      "An unexpected error has occurred. Please try refreshing the page or contact support if the issue persists.",
    buttonText: "Refresh Page"
  }
};

export const loginTexts = {
  emailPlaceholder: "you@company.com",
  typeText: "text",
  passwordPlaceholder: "password",
  passwordMask: "********",
  oneTimePasswordPrompt: "Enter the code we emailed you",
  twoFactorAuthenticationCode: "2FA authentication code"
};
export const tooltiptextId = {
  default: "expand-collapse-tooltip",
  bannerId: "bannerd-expand-collapse-tooltip",
  ltvReportId: "ltv-report-expand-collapse-tooltip",
  customerRepDetailsId: "customer-repayment-details-tooltip",
  fundingPdfId: "funding-pdf-download-tooltip",
  monthlyKpiReportId: "monthly-kpi-report-expand-collapse-tooltip"
};

export const commissionModal = {
  filterTypes: {
    trail: "trail",
    upfront: "upfront"
  },
  titles: {
    trail: "Breakdown of Fees and Trail Commissions",
    upfront: "Breakdown of Fees and Upfront Commissions"
  },
  headers: {
    quoteId: "Quote ID",
    clientName: "Client Name",
    fundedAt: "Funded At",
    completedAt: "Completed At",
    repaymentDate: "Repayment Date",
    feesAmount: "Fees Amount",
    commissionAmount: "Commission Amount"
  },
  totalRow: {
    ratioLabel: "Fees to Commission Ratio:"
  },
  explanation: {
    text: "This means that for every unit of commission paid, you are earning",
    unitsText:
      "units in fees. Therefore, the ratio can be calculated as Fees to Commission Ratio = Total Fees / Total Commission."
  }
};

export const pricingPlanLogs = {
  theading: {
    changeHistory: "Changes history",
    updatedBy: "Updated By",
    updatedAt: "Updated at",
    ip: "IP"
  },
  from: "From",
  pricingPlan: "Pricing Plan :",
  to: "to",
  note: "Note :",
  noteText: 'Users assigned "Standard" pricing plan by default.',
  apiErrorText: "Failed to load pricing plan logs.",
  noHistory: "No history found"
};

export const syncMessages = {
  notSyncedMessage: "Data not Synced"
};

export const fundTap = "FundTap";
export const Ownership = "Ownership";
export const TrustCorporate = "Trust & Corporate";
export const refreshHeader = "refreshHeader";
export const fundTapLogo = "FundTap logo";
export const fmfbDataMigration =
  "FR → FMFB delta migration is required to ensure that the FT No is generated correctly and maintains proper sequence within the application.";
export const manualUpdate = "Manual Update";
export const notscored = "Not Scored";
export const noCreditConsent = "NO CREDIT CONSENT";
export const noQuotesFound = "No quotes found.";

export const accountMetaUpdate = {
  successMsg: "updated successfully.",
  item1: "Industry classification",
  item2: "Industry",
  item3: "Country",
  item4: "Organisation Type"
};

export const accountingSoftwareModalData = {
  welcomeText: "Welcome to FundTap,",
  title: "Select your accounting software",
  content:
    "Connect securely to confirm eligibility for your business and have funding ready when you need it.",
  modalHover: {
    title: "Why link your software?",
    whyChooseList: [
      {
        itemList: "Automatically sync your invoices"
      },
      {
        itemList: "Check eligibility faster"
      },
      {
        itemList: "Speed up funding decisions"
      }
    ],
    securityText: "Secure connection",
    helpText: "Need Help?",
    dontUse: "I don't use any of these"
  }
};

export const accpetQuoteModalData = {
  content:
    "Sorry, we can't fund invoices that are due in less than 3 days. Please adjust the due date using the date picker. You can extend it by up to 5 days from the original due date.",
  before90Days:
    "FundTap cannot fund invoices with payment terms longer than 90 days.",
  futureDays: "FundTap cannot fund invoices dated in the future",
  minInvoiceThreshold: "Invoices $300 or less cannot be submitted for funding"
};

export const tasksBanner = {
  onboarding: {
    header: "Finalise Your Setup",
    body: "Complete these steps to keep things moving. We'll reach out if we need anything else.",
    buttonText: "Continue Setup",
    badgeText: "Required Now"
  },
  reviewing: {
    header: "We're Reviewing Your Details",
    body: "Submit an invoice while we review your details. We'll be in touch within 24 hours if we need anything else to finalise your account.",
    buttonText: "Under Review"
  }
};

export const newOnboardingSteps = {
  onBoardPageTitle: "Finalise Your Setup",
  waitingStepTitle: "WAITING ON OTHERS",
  waitingDirectorSubtitle: "Director",
  agreeLockedSubtitle: "Please complete your ID verification",
  allTasksCompleted: "All done! Taking you to your invoice dashboard.",
  onBoardPageContent:
    "Complete the required steps below to confirm access to funding. Your progress saves automatically. You can return at any time.",
  requiredTitle: "Required steps",
  footerText: "Need help?",
  backToInvoices: "Back to My Invoices",
  aboutBusiness: {
    overviewTitle: "Business Overview",
    overviewSubtitle: "Tell us about your business in your own words.",
    aboutTextArea:
      "e.g. We're a civil construction company based in Auckland. We work with commercial developers and councils on small to mid-sized infrastructure projects. We invoice progressively as milestones are completed, typically on 30 to 60 day terms. Our main costs are wages, subcontractors, and materials, so timing between paying suppliers and receiving payment can create cashflow gaps.",
    facilitySizeTitle: "Facility Size",
    facilitySizeSubtitle: "What size facility do you need?"
  },
  yourRole: {
    yourRoleTitle: "What's Your Role In The Business?",
    yourRoleSubtitle: "Select your role in the business",
    consentTitle: "Consent",
    consentSubtitle: {
      content1: "To meet our",
      content2: "AML",
      content3: "and",
      content4: "KYC",
      content5:
        "obligations and assess your eligibility, Fundtap requires your consent to obtain",
      content6: "identity and credit checks"
    },
    consentText: {
      content1: "I consent to Fundtap obtaining",
      content2: "identity and credit checks",
      content3: "for eligibility assessment."
    },
    roleInfoContent: {
      title: "A quick heads-up",
      content1:
        "To access funding, the business owners or directors will need to complete a quick credit and identity check.",
      content2:
        "You're welcome to keep filling in the details in the meantime. When it's their turn, we'll reach out and guide them through the rest."
    }
  },
  verifyIdentity: {
    verifyTitle: "Verify Your Identity",
    verifySubtitle:
      "Scan the QR code with your mobile device camera to link to APLYiD and complete your ID check. You will need your drivers licence or passport handy for this step.",
    applyIdTitle: "Official APLYiD verification",
    cantGetQr: "Can't scan the QR code? Send link to mobile",
    backQrBtn: "Back to QR code",
    mobNo: "Mobile phone number",
    infoModal: {
      title: "Why we verify your identity",
      content1:
        "As part of providing a financial product, Fundtap must verify your identity.",
      content2:
        "We use APLYiD to securely complete this check. You will be asked to verify your identity using your driver licence or passport.",
      content3:
        "All personal data is encrypted. APLYiD does not store your information beyond the period set out in its privacy policy."
    }
  },
  pepoleInBusiness: {
    businessTitle: "Verify Your Business Details",
    businessSubtitle:
      "Please confirm these details are correct. If anything is incorrect, update it below.",
    stillNeeded: "Still needed:"
  },
  propertyDetails: {
    propertyTitle: "Property Details",
    propertySubtitle: "Required for funding over $30,000",
    propertyInfoContent:
      "To help us get a clearer picture of the business and its owners' financial position, please provide some basic details about property ownership.",
    MortgageTitle: "Mortgage Statement",
    MortgageSubtitle: "Recent statement (within 3 months)",
    MortgageUploadText: "Upload mortgage statement",
    exceptFiles: "PDF, JPG, PNG or HEIC",
    dontHaveMortGae: "I don’t have a mortgage"
  },
  supportingCompanyDetails: {
    stepTitle: "Supporting Company Details",
    businessTitle: "Verify Your Business Details",
    businessSubtitle:
      "Please confirm these details are correct. If anything is incorrect, update it below.",
    addDirectorsTitle: "Add Your Directors",
    addDirectorsSubtitle: "Include any additional directors not already listed",
    addDirectorBtn: "Add Director",
    addShareholdersTitle: "Add Shareholders",
    addShareholdersSubtitle:
      "Provide details for shareholders with 25% or more ownership",
    addShareholderBtn: "Add Shareholder"
  },
  trustDetailsStep: {
    trustDetailsTitle: "Trust Details",
    verifyTrustTitle: "Verify Your Trust Details",
    verifyTrustSubtitle:
      "Please confirm these details are correct. If anything is incorrect, update it below.",
    addTrusteesTitle: "Add Trustees",
    addTrusteesSubtitle: "List all trustees involved in managing your trust",
    addTrusteeBtn: "Add Trustee",
    uploadTitle: "Upload Trust Deed And Amendments",
    uploadSubtitle:
      "Upload your trust deed and any amendments that have been made",
    trustDeedLabel: "Trust deed",
    amendmentsLabel: "Amendments (optional)",
    trustDeedUploadTitle: "Upload Trust Deed",
    amendmentsUploadTitle: "Upload Amendments",
    pdfOnly: "PDF only",
    addMoreBtn: "Add more",
    legalNameTooltip:
      "Enter their legal first and last name as it appears on official documents.",
    professionalTrusteeLabel: "Professional trustee",
    professionalCommTitle: "Professional Trustee Communication",
    contactMyselfOption:
      "I'll contact them myself, just send me what they need",
    contactOnBehalfOption: "Yes, contact them on my behalf",
    companyNameLabel: "Company Name",
    companyNamePlaceholder: "Enter company name",
    directorLegalNameLabel: "Director's Legal Name",
    directorEmailLabel: "Director Email Address",
    directorMobileLabel: "Director Mobile Number"
  },
  fundingRepaymentsDetails: {
    fundingTitle: "Funding Account",
    fundingSubtitle: "Select where you'd like to receive funds",
    addBankAccount: "Or Add Bank Account Manually",
    setUpTitle: "Repayment Setup",
    setUpSubtitle:
      "Automatic repayments via direct debit from the account above",
    backBtn: "Back to accounts",
    verifyAccount: "To verify the bank account",
    goCardlessSetupTitle: "GoCardless Direct Debit Setup",
    goCardlessSetupSubtitle: "Secure payment authorization",
    goCardlessAwaitingBank:
      "Complete your funding account details above to start the Direct Debit setup."
  },
  whatYouAgreeDetails: {
    agreeTitle: "Review And Sign Documents",
    agreeSubtitle:
      "Review and digitally sign each document with your witness present",
    requiredTitle: "Witness Requirements",
    requiredSubtitle:
      "Your witness must not be a business associate and must be over 18.",
    ftAgreementTitle: "Fundtap Agreement",
    ftAgreementText: "Terms and conditions for Fundtap funding services.",
    trustGuaranteeTitle: "Trust Guarantee",
    trustGuaranteeText:
      "Guarantee provided by the trust entity for funding arrangements.",
    corporateGuaranteeTitle: "Corporate Guarantee",
    corporateGuaranteeText:
      "Guarantee from related companies to secure the funding facility.",
    signBtn: "Sign Document",
    status: "Signed"
  },
  verifyIdDetails: {
    sentTo: "Sent to:",
    sentToUnnamedDirector:
      "Sent to the director who has to complete this step.",
    sentToContent:
      "They'll need to provide the required information before you can proceed.",
    footerInfo: "Need to follow up? Send a reminder."
  },
  formLabelandData: {
    businessType: "Business Type",
    trustName: "Trust Name",
    trustNamePlaceHolder: "Enter trust name",
    legalTtrading: "Legal Trading Name",
    legalTtradingPlaceHolder: "Enter legal trading name",
    nzbnAbn: "NZBN or ABN",
    nzbnAbnPlaceHolder: "Enter NZBN or ABN",
    nzbnAbnAu: "ABN",
    nzbnAbnAuPlaceHolder: "Enter ABN",
    nzbnAbnNz: "NZBN",
    nzbnAbnNzPlaceHolder: "Enter NZBN",
    shareHolderType: "Shareholding Type",
    shareHolderPercent: "Percentage of Shareholding",
    trusteeType: "Trustee Type",
    legalName: "Legal Name",
    enterEmail: "Enter email address",
    mobNo: "Mobile Number",
    enterMobNo: "Enter mobile number",
    propertyAddress: "Property Address",
    propertyAddressPlaceHolder: "Start typing the property address...",
    propertyAddressinfo:
      "We'll search for the property details automatically as you type",
    propertyOwned: "How is this property owned?",
    propertyOwner: "Property Owners",
    trustDetails: "Trust Details",
    trustDetailsPlaceHolder: "Enter the trust name",
    companyDetails: "Company Details",
    companyDetailsPlaceHolder: "Enter the company name",
    bankName: "Bank Name",
    accountHolderName: "Account Holder Name",
    accountHolderNamePlaceHolder: "Account holder name",
    bankCode: "Bank Code",
    bankCodePlaceHolder: "01",
    branchCode: "Branch Code",
    branchCodePlaceHolder: "0004",
    auBranchCodePlaceHolder: "082-082",
    accountNumberCode: "Account Number",
    accountNumberPlaceHolder: "3333333",
    auAccountNumberPlaceHolder: "012345678",
    suffixCode: "Suffix",
    suffixPlaceHolder: "44",
    bankCodeLengthError: "Enter the 2-digit bank code",
    branchCodeLengthError: "Enter the 4-digit branch code",
    accountNumberLengthError: "Enter the 7-digit account number",
    suffixLengthError: "Enter the 2 or 3-digit suffix",
    auBranchCodeLengthError: "Enter the 6-digit BSB",
    auAccountNumberLengthError: "Enter the 5 to 9-digit account number",
    bankStatement: "Bank Statement",
    uploadBankStatement: "Upload bank statement",
    fileAccept: "PDF, JPG, PNG or HEIC"
  }
};
export const toastText = {
  permissionDenied: "You do not have permission to switch Approve status."
};
// overdue tooltip id and text
export const overduetooltip = {
  id: "overdue-tooltip",
  text: "Overdue invoices are not eligible for repayment date changes"
};

export const completedTooltip = {
  id: "completed-tooltip",
  text: "Completed invoices are not eligible for repayment date changes"
};

export const unrecoverableTooltip = {
  id: "unrecoverable-tooltip",
  text: "Unrecoverable invoices are not eligible for repayment date changes"
};

export const paymentInitiatedTooltip = {
  id: "payment-initiated-tooltip",
  text: "This invoice has allocated payments, so the repayment date cannot be changed"
};

// {{status}} is replaced with the invoice's externalInvoiceStatus value.
export const externalInvoiceStatusTooltip = {
  id: "external-invoice-status-tooltip",
  text: "Can't change repay date because invoice is {{status}}."
};

export const owingZeroData = {
  headers: {
    createdDate: "Created Date",
    entity: "Entity",
    quoteId: "Quote ID",
    totalOwing: "Total Owing"
  },
  filter: {
    fromDate: "From Date (created at)",
    toDate: "To Date (created at)",
    filterBtn: "Filter",
    excelBtn: "Excel"
  }
};

export const idealTimeOutContent = {
  title: "Inactivity Timeout Warning!",
  content: `Account is inactive for 15 minutes. Popup will auto close in <b></b> seconds. User will be logged out if no action is taken.`,
  moreTime: "Get more time",
  logout: "Logout"
};

export const metaPixel = {
  submitMultipleInvoices: "SubmitMultipleInvoices",
  submitInvoice: "SubmitInvoice",
  approved: "Approved",
  preApproved: "PreApproved",
  connectAccountingSoftware: "ConnectAccountingSoftware",
  completeRegistration: "CompleteRegistration"
};

export const customerLogType = {
  consentAccept: "Credit/Identity Consent accepted"
};

export const statementForm = {
  main_title: "Generate Statement",
  startDate: "Start Date",
  endDate: "End Date",
  downloadBtn: "Download PDF",
  downloading: "Downloading...",
  downloadSuccess: "PDF downloaded successfully",
  downloadError: "Failed to download PDF",
  errorValidation: {
    startDateValid: "Start Date is required.",
    endDateValid: "End Date is required.",
    startDateError: "Start Date cannot be after End Date."
  }
};
export const acceptQuoteModalData = {
  content:
    "Sorry, we can't fund invoices that are due in less than 3 days. Please adjust the due date using the date picker. You can extend it by up to 5 days from the original due date.",
  before90Days:
    "FundTap cannot fund invoices with payment terms longer than 90 days.",
  futureDays: "FundTap cannot fund invoices dated in the future",
  minInvoiceThreshold: "Invoices $300 or less cannot be submitted for funding"
};

export const ALL_INVOICE_BATCH_FILENAME = "all_invoice_batch_data.csv";

export const allInvoiceBatchData = {
  errMsg: {
    item1: "Successfully downloaded",
    item2: "Failed to download invoice batch data"
  }
};

export const ppRequiredModalData = {
  title: "Payment proof required",
  content1:
    "It appears the total funding may exceed your current credit limit. If you've recently had a FundTap direct debit come out of your account, please attach a screenshot of the bank payment confirmation showing the account balance immediately after the payment has been taken.",
  content2:
    "If your current limit isn’t keeping up with your business needs, you can request a credit increase.",
  uploadField: "Upload bank statement",
  creditLimit: "Credit limit increase",
  selectFileError: "Please select at least one file to upload.",
  uploadSuccess: "File(s) uploaded successfully.",
  invalidFileType: "is not an allowed file type."
};

// Invoice-funding processing window: one FundTap business day, 9am-7pm NZ
// time, expressed in the customer's local time (AU sits two hours behind NZ).
export const PROCESSING_HOURS = {
  NZ: { openHour: 9, closeHour: 19 },
  AU: { openHour: 7, closeHour: 17 }
};

// Partner-portal "Add a client" modal (pages/partner-portal/AddCustomerModal.jsx).
// The success copy is split into fragments because the rendered sentence
// interpolates the client's email, business name and the Pending / Customer DD
// status names, which are bolded inline.
export const addClientModal = {
  title: "Add a client",
  subtitle:
    "We'll send them a sign-up link. You'll earn from their first funded invoice.",
  shareLabel: "Or share your link",
  copyLink: "Copy link",
  copied: "Copied!",
  labels: {
    businessName: "Business name",
    firstName: "First name",
    lastName: "Last name",
    email: "Email",
    phone: "Phone",
    documents: "Financial documents",
    optional: "(optional)",
    notes: "Notes (optional)"
  },
  placeholders: {
    businessName: "e.g. Acme Plumbing Ltd",
    firstName: "First name",
    lastName: "Last name",
    email: "name@business.co.nz",
    phone: "021 …",
    notes: "Anything useful for the FundTap team — deal context, timing, etc."
  },
  upload: {
    title: "Click to upload documents",
    hint: "Attach bank statements, financials or receivables.",
    addMore: "+ Add more",
    removeDocument: "Remove document"
  },
  buttons: {
    cancel: "Cancel",
    sendLink: "Send sign-up link",
    sending: "Sending…",
    sendPreassessment: "Send for pre-assessment",
    done: "Done"
  },
  errMsg: {
    businessNameRequired: "Business name is required.",
    firstNameRequired: "First name is required.",
    lastNameRequired: "Last name is required.",
    emailRequired: "Email address is required.",
    emailInvalid: "Enter a valid email address.",
    phoneInvalid: "Enter a valid phone number.",
    createFailed: "Couldn't add this client. Please try again.",
    docsNoId:
      "The client was created, but we didn't get their id back to attach the documents. Please send the documents to your FundTap contact.",
    docsUploadFailed:
      "The client was created, but their documents didn't upload"
  },
  success: {
    linkTitle: "Sign-up link sent",
    preassessTitle: "Sent for pre-assessment",
    linkEmailedPrefix: "We've emailed",
    linkEmailedMiddle: "with their sign-up link.",
    linkShowUnder: "will show up under",
    clientBook: "in your client book.",
    preassessReceivedPrefix: "FundTap has received",
    preassessReceivedSuffix: "'s details. They'll show up under",
    preassessMoveInto:
      "in your client book — a FundTap team member will move them into",
    preassessReviewSuffix: "once they begin the pre-assessment review."
  }
};

export const referralLogin = {
  noInvoiceMessage:
    "No invoices yet — this client is still working through onboarding."
};
